import React from 'react';
import { DefaultButton, PrimaryButton, CommandBarButton, Stack, Checkbox as Checkbox$1, ChoiceGroup as ChoiceGroup$1, unregisterIcons, initializeIcons as initializeIcons$1, registerIcons, mergeStyleSets, Icon, DropdownMenuItemType, SelectableOptionMenuItemType, SearchBox, Text, Dropdown as Dropdown$1, TextField, TagPicker as TagPicker$1, Toggle as Toggle$1, DialogType, Dialog, DialogFooter, Spinner, SpinnerSize, MessageBar } from '@fluentui/react';
export { AnimationClassNames, Breadcrumb, Calendar, Callout, CheckboxVisibility, ChoiceGroupOption, CommandBar, ContextualMenu, ContextualMenuItemType, DatePicker, DayOfWeek, DetailsListLayoutMode, DetailsRow, Dialog, DialogFooter, DialogType, DirectionalHint, Fabric, Facepile, FirstWeekOfYear, FocusZone, Icon, IconButton, Image, ImageFit, Label, Link, List, MarqueeSelection, MessageBar, MessageBarType, Nav, NormalPeoplePicker, OverflowButtonType, Panel, PanelType, PeoplePickerItem, Persona, PersonaPresence, PersonaSize, Pivot, PivotItem, ProgressIndicator, ScrollablePane, Selection, SelectionMode, Separator, Shimmer, ShimmerElementType, ShimmerElementsGroup, ShimmeredDetailsList, Spinner, SpinnerSize, Stack, Sticky, TagItem, Text, TextField, TooltipHost, getFocusStyle, getTheme, mergeStyleSets } from '@fluentui/react';
import { createTheme, Customizer, MessageBarType } from 'office-ui-fabric-react';
import color from 'color';
import classNames$1 from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = function Button(_ref) {
  var testId = _ref.testId,
      _ref$alignIcon = _ref.alignIcon,
      alignIcon = _ref$alignIcon === void 0 ? 'left' : _ref$alignIcon,
      primary = _ref.primary,
      hasMenu = _ref.hasMenu,
      commandBar = _ref.commandBar,
      menuProps = _ref.menuProps,
      iconProps = _ref.iconProps,
      styles = _ref.styles,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["testId", "alignIcon", "primary", "hasMenu", "commandBar", "menuProps", "iconProps", "styles", "children"]);

  var ButtonComponent = DefaultButton;
  if (primary) ButtonComponent = PrimaryButton;else if (commandBar || hasMenu) ButtonComponent = CommandBarButton;
  var buttonStyles = React.useMemo(function () {
    return _extends({}, styles || {}, {
      icon: _extends({}, (styles == null ? void 0 : styles.icon) || {}, {
        order: alignIcon === 'right' ? 1 : 0
      })
    });
  }, [alignIcon, styles]);
  return /*#__PURE__*/React.createElement(ButtonComponent, Object.assign({
    "data-test": testId,
    styles: buttonStyles,
    iconProps: iconProps,
    menuProps: menuProps
  }, props), children);
};

var ButtonGroup = function ButtonGroup(_ref) {
  var testId = _ref.testId,
      _ref$horizontalAlign = _ref.horizontalAlign,
      horizontalAlign = _ref$horizontalAlign === void 0 ? 'end' : _ref$horizontalAlign,
      _ref$horizontal = _ref.horizontal,
      horizontal = _ref$horizontal === void 0 ? true : _ref$horizontal,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["testId", "horizontalAlign", "horizontal", "children"]);

  return /*#__PURE__*/React.createElement(Stack, Object.assign({
    "data-test": testId,
    horizontalAlign: horizontalAlign,
    horizontal: horizontal,
    tokens: {
      childrenGap: 24
    }
  }, props), children);
};

var DIALOG_MIN_HEIGHT = 300;
var DIALOG_HEADER_HEIGHT = 56;
var CHECKGROUP_ERROR = 'ms-CheckGroup-error';
var CHECKGROUP_SUCCESS = 'ms-CheckGroup-success';
var CHECKBOX_ERROR = 'ms-Checkbox-error';
var CHECKBOX_SUCCESS = 'ms-Checkbox-success';

var Checkbox = function Checkbox(_ref) {
  var testId = _ref.testId,
      checkmarkIconProps = _ref.checkmarkIconProps,
      label = _ref.label,
      error = _ref.error,
      success = _ref.success,
      props = _objectWithoutPropertiesLoose(_ref, ["testId", "checkmarkIconProps", "label", "error", "success"]);

  var className = '';
  if (error) className = CHECKBOX_ERROR;else if (success) className = CHECKBOX_SUCCESS;
  var checkboxCheckmarkIconProps = React.useMemo(function () {
    return _extends({
      iconName: 'checkboxChecked12'
    }, checkmarkIconProps || {});
  }, [checkmarkIconProps]);
  return /*#__PURE__*/React.createElement(Checkbox$1, Object.assign({
    className: className,
    "data-test": testId,
    label: label,
    checkmarkIconProps: checkboxCheckmarkIconProps
  }, props));
};

var ChoiceGroup = function ChoiceGroup(_ref) {
  var testId = _ref.testId,
      error = _ref.error,
      success = _ref.success,
      options = _ref.options,
      props = _objectWithoutPropertiesLoose(_ref, ["testId", "error", "success", "options"]);

  var className = '';
  if (error) className = CHECKGROUP_ERROR;else if (success) className = CHECKGROUP_SUCCESS;
  return /*#__PURE__*/React.createElement(ChoiceGroup$1, Object.assign({
    className: className,
    "data-test": testId,
    options: options
  }, props));
};

var nuOrderPalette = {
  textPrimary: '#2D2D2D',
  textSecondary: '#585858',
  disabled: '#BDBDBD',
  error: '#E7645C',
  linkHover: '#008C84',
  linkDefault: '#00A9A4',
  success: '#4AA06B',
  white: '#ffffff'
}; // we can generate with: https://fabricweb.z5.web.core.windows.net/pr-deploy-site/refs/heads/master/theming-designer/index.html

var palette = /*#__PURE__*/_extends({
  commandBarBorderColor: '#edebe9',
  sectionBackground: '#FAF9F8',
  dragEnterColor: '#97aaaf',
  selectedDropdownItemBackground: 'rgb(237, 235, 233)',
  textColor: nuOrderPalette.textPrimary,
  themePrimary: '#089E98',
  themeLighterAlt: '#AFDCDC',
  themeLighter: '#7ac6c4',
  themeLight: '#42afab',
  themeDark: '#028d87',
  themeDarkAlt: '#007169',
  themeDarker: '#008079',
  black: '#2d2d2d',
  neutralLighter: '#f6f6f6',
  neutralLight: '#e1e1e1',
  neutralQuaternary: '#d0d0d0',
  neutralTertiary: '#c2c2c2',
  neutralSecondary: '#858585',
  neutralPrimary: '#333333',
  neutralDark: '#272727',
  greyLightest: '#f5f5f5',
  greyDarker: '#585858',
  greyDark: '#8e8e8e',
  greyBase: '#bdbdbd',
  disabledInputBackground: 'rgb(243, 242, 241)',
  disabledInputColor: nuOrderPalette.disabled,
  secondaryLightest: '#e6f2f9',
  secondaryLighter: '#a1cbe5',
  secondaryLight: '#6fa6d1',
  secondaryBase: '#568bbd',
  secondaryDark: '#4c7aab',
  secondaryDarker: '#436a99',
  secondaryDarkest: '#344e78',
  successBase: nuOrderPalette.success,
  successLight: '#9fd4b4',
  successLighter: '#f0fbf4',
  warningBase: '#ffd300',
  warningLight: '#ffe77d',
  warningLighter: '#fffcda',
  errorBase: nuOrderPalette.error,
  errorLight: '#ffbbb6',
  errorLighter: '#fff5f4'
}, nuOrderPalette);

var CheckboxStyles = function CheckboxStyles(theme) {
  return function (props) {
    var disabled = props.disabled,
        checked = props.checked,
        indeterminate = props.indeterminate,
        className = props.className;
    return {
      text: [{
        color: theme.palette.black
      }, className === CHECKBOX_ERROR && {
        color: theme.palette.errorBase
      }, className === CHECKBOX_SUCCESS && {
        color: theme.palette.successBase
      }, disabled && {
        color: theme.palette.greyDark
      }],
      checkbox: [{
        height: 18,
        maxHeight: 18,
        width: 18,
        maxWidth: 18,
        borderWidth: 2,
        borderStyle: 'solid',
        borderRadius: 4,
        backgroundColor: indeterminate ? theme.palette.themePrimary : theme.palette.white,
        borderColor: indeterminate ? theme.palette.themePrimary : theme.palette.greyDark,
        selectors: {
          '::after': {
            backgroundColor: theme.palette.white,
            height: 2,
            top: '7px',
            left: '2px',
            border: 0
          }
        }
      }, className === CHECKBOX_ERROR && {
        borderColor: theme.palette.errorBase
      }, className === CHECKBOX_ERROR && checked && {
        backgroundColor: theme.palette.errorBase,
        borderColor: theme.palette.errorBase
      }, className === CHECKBOX_SUCCESS && {
        borderColor: theme.palette.successBase
      }, className === CHECKBOX_SUCCESS && checked && {
        backgroundColor: theme.palette.successBase,
        borderColor: theme.palette.successBase
      }, checked && {
        backgroundColor: theme.palette.themePrimary
      }, disabled && {
        borderColor: theme.palette.greyDark,
        backgroundColor: indeterminate ? theme.palette.greyDark : theme.palette.white
      }, disabled && checked && {
        borderColor: theme.palette.greyDark,
        backgroundColor: theme.palette.greyDark
      }],
      checkmark: [{
        color: indeterminate ? theme.palette.themePrimary : theme.palette.white,
        fontWeight: 900,
        height: 'auto',
        width: 12,
        position: 'relative',
        top: '1px'
      }],
      root: [{
        selectors: {
          '.ms-Checkbox-label': {
            fontFamily: 'Lato, sans-serif',
            fontSize: '14px',
            letterSpacing: '0.16px',
            color: theme.palette.black
          }
        }
      }, !disabled && [!checked && {
        selectors: {
          ':hover .ms-Checkbox-label .ms-Checkbox-checkbox': {
            borderColor: theme.palette.greyDark
          },
          ':hover .ms-Checkbox-label .ms-Checkbox-checkmark .checkMark': {
            stroke: theme.palette.greyDark,
            opacity: '1'
          }
        }
      }, checked && {
        selectors: {
          '.ms-Checkbox-label .ms-Checkbox-checkbox': {
            background: theme.palette.themePrimary,
            borderColor: theme.palette.themePrimary
          },
          ':hover .ms-Checkbox-label .ms-Checkbox-checkbox': {
            borderColor: theme.palette.themePrimary,
            backgroundColor: theme.palette.themePrimary
          }
        }
      }, indeterminate && checked && {
        selectors: {
          '.ms-Checkbox-label .ms-Checkbox-checkbox': {
            background: theme.palette.themePrimary,
            borderColor: theme.palette.themePrimary
          },
          ':hover .ms-Checkbox-label .ms-Checkbox-checkbox': {
            borderColor: theme.palette.themePrimary,
            backgroundColor: theme.palette.themePrimary
          }
        }
      }, className === CHECKBOX_ERROR && {
        selectors: {
          ':hover .ms-Checkbox-label .ms-Checkbox-checkbox': {
            borderColor: theme.palette.errorBase
          },
          ':hover .ms-Checkbox-label': {
            color: theme.palette.errorBase
          },
          ':hover .ms-Checkbox-text': {
            color: theme.palette.errorBase
          }
        }
      }, className === CHECKBOX_ERROR && checked && {
        selectors: {
          '.ms-Checkbox-label .ms-Checkbox-checkbox': {
            background: theme.palette.errorBase
          },
          ':hover .ms-Checkbox-label .ms-Checkbox-checkbox': {
            borderColor: theme.palette.errorBase,
            backgroundColor: theme.palette.errorBase
          }
        }
      }, className === CHECKBOX_SUCCESS && {
        selectors: {
          ':hover .ms-Checkbox-checkbox': {
            borderColor: theme.palette.successBase
          },
          ':hover .ms-Checkbox-label': {
            color: theme.palette.successBase
          },
          ':hover .ms-Checkbox-text': {
            color: theme.palette.successBase
          }
        }
      }, className === CHECKBOX_SUCCESS && checked && {
        selectors: {
          '.ms-Checkbox-label .ms-Checkbox-checkbox': {
            background: theme.palette.successBase
          },
          ':hover .ms-Checkbox-label .ms-Checkbox-checkbox': {
            borderColor: theme.palette.successBase,
            backgroundColor: theme.palette.successBase
          }
        }
      }]]
    };
  };
};

var DefaultButtonStyles = function DefaultButtonStyles(theme, primary) {
  return {
    root: {
      maxHeight: '40px',
      height: '40px',
      padding: '0 32px',
      border: primary ? "1px solid " + theme.palette.themePrimary : "1px solid " + theme.palette.greyBase,
      borderRadius: '24px',
      backgroundColor: primary ? theme.palette.themePrimary : theme.palette.white,
      color: primary ? theme.palette.white : theme.palette.greyBase,
      '&:focus::after': {
        outline: 'none !important'
      }
    },
    rootDisabled: {
      borderColor: primary ? theme.palette.neutralLight : theme.palette.greyBase,
      color: primary ? theme.palette.greyDark : theme.palette.greyDark,
      backgroundColor: primary ? theme.palette.neutralLight : theme.palette.neutralLight
    },
    rootHovered: {
      borderColor: primary ? theme.palette.themeDarker : theme.palette.greyBase,
      color: primary ? theme.palette.white : theme.palette.greyDarker,
      backgroundColor: primary ? theme.palette.themeDarker : theme.palette.neutralLighter
    },
    rootFocused: {
      borderColor: primary ? theme.palette.themeDarker : theme.palette.greyBase,
      color: primary ? theme.palette.white : theme.palette.greyDarker,
      backgroundColor: primary ? theme.palette.themeDarker : theme.palette.neutralLighter
    },
    rootPressed: {
      backgroundColor: primary ? theme.palette.themeDarker : theme.palette.greyBase,
      borderColor: primary ? theme.palette.themeDarker : theme.palette.greyBase,
      color: primary ? theme.palette.white : theme.palette.greyDarker
    },
    label: {
      color: primary ? theme.palette.white : theme.palette.greyDarker,
      fontSize: '14px',
      fontWeight: 'normal',
      letterSpacing: '0.18px',
      lineHeight: '1.4',
      margin: '0 4px'
    },
    labelDisabled: {
      color: theme.palette.greyDark
    },
    icon: {
      margin: '0 4px',
      color: primary ? theme.palette.white : theme.palette.black
    },
    iconDisabled: {
      color: theme.palette.greyDark
    }
  };
};

var CommandBarButtonStyles = function CommandBarButtonStyles(theme) {
  return {
    root: {
      maxHeight: '40px',
      height: '40px',
      padding: '0 32px',
      border: 'none',
      backgroundColor: theme.palette.white,
      color: theme.palette.greyBase,
      '&:focus::after': {
        outline: 'none !important'
      },
      '&:focus span': {
        color: theme.palette.themePrimary
      }
    },
    rootDisabled: {
      color: theme.palette.greyDark,
      backgroundColor: theme.palette.white
    },
    rootHovered: {
      color: theme.palette.themePrimary,
      backgroundColor: theme.palette.white
    },
    rootFocused: {
      color: theme.palette.themePrimary,
      backgroundColor: theme.palette.white
    },
    rootPressed: {
      color: theme.palette.themePrimary,
      backgroundColor: theme.palette.white
    },
    label: {
      color: theme.palette.greyDarker,
      fontSize: '14px',
      fontWeight: 'normal',
      letterSpacing: '0.18px',
      lineHeight: '1.4',
      margin: '0 4px'
    },
    labelDisabled: {
      color: theme.palette.greyBase
    },
    labelHovered: {
      color: theme.palette.themePrimary
    },
    icon: {
      margin: '0 4px',
      color: theme.palette.greyDarker
    },
    iconDisabled: {
      color: theme.palette.greyBase
    }
  };
};

var CheckStyles = function CheckStyles(theme) {
  return function (props) {
    var checked = props.checked;
    return {
      circle: {
        borderRadius: 4,
        height: 18,
        maxHeight: 18,
        width: 18,
        maxWidth: 18,
        fontSize: 0,
        paddingTop: 1,
        paddingLeft: 1,
        color: theme.palette.greyDark,
        backgroundColor: checked ? theme.palette.themePrimary : theme.palette.white,
        borderColor: checked ? theme.palette.themePrimary : theme.palette.greyDark,
        borderWidth: 2,
        borderStyle: 'solid'
      },
      check: [{
        height: 18,
        maxHeight: 18,
        width: 18,
        maxWidth: 18,
        fontSize: 18,
        fontWeight: 900,
        top: -1
      }, checked && {
        color: theme.palette.white
      }, !checked && {
        color: theme.palette.greyDark
      }]
    };
  };
};
var DetailsListStyles = function DetailsListStyles(theme) {
  return function (_props) {
    return {
      root: {
        overflow: 'hidden'
      },
      headerWrapper: {
        selectors: {
          '.ms-DetailsHeader': {
            paddingTop: 0,
            borderBottomColor: theme.palette.greyBase
          },
          '.ms-DetailsHeader-cell': {
            ':hover': {
              backgroundColor: theme.palette.white
            },
            '.ms-DetailsHeader-cellName': {
              color: theme.palette.black,
              fontWeight: 'bold',
              fontSize: '12px'
            }
          },
          '.ms-DetailsHeader-check': {
            left: '2px',
            width: '33px !important'
          }
        }
      }
    };
  };
};
var DetailsRowStyles = function DetailsRowStyles(theme) {
  return function (props) {
    var isSelected = props.isSelected;
    return {
      root: {
        borderBottom: "1px solid " + theme.palette.neutralLight,
        height: 60,
        selectors: {
          ':hover': {
            backgroundColor: theme.palette.neutralLighter,
            selectors: {
              '.ms-DetailsRow-cellCheck .ms-Checkbox-checkbox': {
                backgroundColor: !isSelected ? theme.palette.neutralLighter : theme.palette.themePrimary
              }
            }
          },
          '&.is-selected:hover': {
            backgroundColor: theme.palette.neutralLight
          },
          '.ms-DetailsRow-cellCheck': {
            display: 'flex',
            alignItems: 'center',
            marginTop: 0
          }
        }
      },
      check: {
        top: '2px',
        width: '33px !important',
        selectors: {
          '.ms-Checkbox-checkbox': {
            marginRight: 0
          }
        }
      },
      cell: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.black,
        fontSize: '12px',
        selectors: {
          '.ms-Link': {
            fontSize: '12px'
          },
          '> i': {
            display: 'flex',
            color: theme.palette.greyDarker
          },
          '> i svg': {
            fill: theme.palette.greyDarker
          }
        }
      }
    };
  };
};

var DropdownStyles = function DropdownStyles(theme) {
  return function (_props) {
    return {
      root: {
        selectors: {
          '.ms-Dropdown-container': {
            marginTop: '8px',
            marginBottom: '12px',
            padding: '0px 8px'
          },
          '.ms-Dropdown': {
            height: '38px',
            marginTop: '8px',
            border: "1px solid " + theme.palette.greyBase
          },
          '.ms-Dropdown-label': {
            fontSize: '12px',
            fontWeight: '700',
            lineHeight: '16px',
            letterSpacing: '0.16px',
            color: theme.palette.black
          }
        }
      },
      caretDownWrapper: {
        width: '14px',
        height: '36px',
        lineHeight: '38px',
        '& svg': {
          fill: theme.palette.greyDarker
        }
      },
      dropdown: [{
        selectors: {
          ':focus::after': {
            border: 'none'
          },
          ':focus': {
            borderColor: theme.palette.themePrimary
          }
        }
      }],
      title: [{
        padding: '14px 0 14px 8px',
        marginRight: '18px',
        fontSize: '14px',
        fontWeight: '400',
        letterSpacing: '0.16px',
        lineHeight: '10px',
        color: theme.palette.black,
        border: 'none',
        height: '36px'
      }],
      dropdownItem: {
        height: 'auto',
        minHeight: 36,
        padding: '4px 8px'
      },
      dropdownItemSelected: {
        height: 'auto',
        minHeight: 36,
        padding: '4px 8px'
      }
    };
  };
};

var TagItemStyles = function TagItemStyles(theme) {
  return function (_props) {
    var _selectors;

    return {
      root: {
        backgroundColor: theme.palette.neutralLight,
        height: '24',
        borderRadius: '12px',
        padding: '4px 4px 4px 8px',
        fontSize: '12px',
        boxSizing: 'border-box',
        lineHeight: 'normal',
        margin: '0',
        selectors: (_selectors = {}, _selectors['.ms-TagItem-close .ms-Button-icon'] = {
          fontWeight: 'bold'
        }, _selectors)
      },
      text: {
        margin: '0',
        color: theme.palette.black
      }
    };
  };
};

var TagPickerStyles = function TagPickerStyles(_theme) {
  return function (_props) {
    return {
      input: {
        height: '24px',
        padding: '0'
      },
      text: {
        padding: '6px 40px 6px 7px'
      }
    };
  };
};

var ChoiceGroupOptionStyles = function ChoiceGroupOptionStyles(theme) {
  return function (props) {
    var checked = props.checked,
        disabled = props.disabled;
    return {
      field: [{
        selectors: {
          // The circle
          '::before': [{
            borderWidth: '2px',
            borderColor: checked ? theme.palette.themePrimary : theme.palette.greyDarker
          }, disabled && {
            borderColor: theme.palette.greyDark
          }],
          ':hover': [!disabled && !checked && {
            selectors: {
              '::before': {
                borderColor: theme.palette.greyDarker
              },
              '::after': {
                backgroundColor: 'transparent'
              }
            }
          }, !disabled && checked && {
            selectors: {
              '::before': {
                borderColor: theme.palette.themePrimary
              },
              '::after': {
                backgroundColor: theme.palette.themePrimary
              }
            }
          }],
          '.ms-ChoiceFieldLabel': {
            letterSpacing: '0.16px',
            color: disabled ? theme.palette.greyDark : theme.palette.black
          }
        }
      }]
    };
  };
};

var SuggestionItemStyles = function SuggestionItemStyles(theme) {
  return function (_props) {
    return {
      root: {
        selectors: {
          '::after': {
            border: 'none'
          }
        }
      },
      itemButton: {
        border: 'none',
        paddingRight: '2px',
        height: '52px',
        borderRadius: 0,
        backgroundColor: theme.palette.white + " !important",
        selectors: {
          ':hover': {
            backgroundColor: theme.palette.neutralLight + " !important"
          },
          '.ms-Persona': {
            selectors: {
              '.ms-Persona-coin': {
                paddingLeft: '12px'
              },
              '.ms-Persona-imageArea': {
                width: '32px',
                height: '32px'
              },
              '.ms-Persona-initials': {
                height: '32px',
                lineHeight: '32px'
              }
            }
          }
        }
      }
    };
  };
};

var TextFieldStyles = function TextFieldStyles(theme) {
  return function (props) {
    var disabled = props.disabled,
        hasErrorMessage = props.hasErrorMessage,
        focused = props.focused;
    return {
      wrapper: {
        padding: '8px 0',
        selectors: {
          '.ms-Label': [{
            fontSize: '12px',
            fontWeight: '700',
            letterSpacing: '0.16px',
            lineHeight: '16px'
          }, disabled && {
            color: theme.palette.greyDark
          }],
          'input.ms-TextField-field': [{
            height: '38px',
            fontSize: '14px',
            fontWeight: '400',
            letterSpacing: '0.16px',
            lineHeight: '20px',
            color: theme.palette.black
          }, disabled && {
            backgroundColor: theme.palette.neutralLighter + " !important",
            borderColor: theme.palette.neutralLight
          }, focused && {
            borderColor: theme.palette.themePrimary
          }, hasErrorMessage && {
            backgroundColor: theme.palette.errorLighter,
            borderColor: theme.palette.errorBase + " !important"
          }]
        }
      },
      fieldGroup: {
        height: '38px',
        border: "1px solid " + theme.palette.greyBase,
        borderRadius: '3px',
        selectors: {
          ':hover': {
            borderColor: theme.palette.greyBase
          },
          '::after': {
            borderRadius: '3px',
            borderWidth: 1
          }
        }
      },
      errorMessage: {
        marginLeft: '8px',
        padding: 0,
        color: theme.palette.errorBase
      }
    };
  };
};

var LabelStyles = function LabelStyles(theme) {
  return function (props) {
    var disabled = props.disabled;
    return {
      root: [{
        fontSize: '12px',
        fontWeight: '700',
        letterSpacing: '0.16px',
        lineHeight: '16px'
      }, disabled && {
        color: theme.palette.greyDark
      }]
    };
  };
};

var SURFACES = {
  DIALOG: {
    TITLE: 'dialog-title',
    CONTAINER: 'dialog-container',
    INPUT: 'name-input',
    ERROR: 'error-text',
    CANCEL_BTN: 'cancel-btn',
    CUSTOM_LEFT_BTN: 'custom-left-btn',
    SAVE_BTN: 'save-btn',
    OK_BTN: 'ok-btn'
  }
};

var BASIC_INPUT = {
  MULTI_SELECT: {
    DROPDOWN: 'multi-select-dropdown',
    TITLE: 'multi-select-title',
    SEARCH_AREA: 'multi-select-search-area'
  },
  TAG_PICKER: {
    LOADING: 'tag-picker-loading'
  }
};

var DATATEST = {
  SURFACES: SURFACES,
  BASIC_INPUT: BASIC_INPUT
};

var Keys;

(function (Keys) {
  Keys[Keys["TAB"] = 9] = "TAB";
  Keys[Keys["NEW_LINE"] = 10] = "NEW_LINE";
  Keys[Keys["ENTER"] = 13] = "ENTER";
  Keys[Keys["SHIFT"] = 16] = "SHIFT";
  Keys[Keys["LEFT"] = 37] = "LEFT";
  Keys[Keys["UP"] = 38] = "UP";
  Keys[Keys["RIGHT"] = 39] = "RIGHT";
  Keys[Keys["DOWN"] = 40] = "DOWN";
  Keys[Keys["DELETE"] = 46] = "DELETE";
  Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
  Keys[Keys["F2"] = 113] = "F2";
  Keys[Keys["PAGE_UP"] = 33] = "PAGE_UP";
  Keys[Keys["PAGE_DOWN"] = 34] = "PAGE_DOWN";
  Keys[Keys["PAGE_HOME"] = 36] = "PAGE_HOME";
  Keys[Keys["PAGE_END"] = 35] = "PAGE_END";
  Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
  Keys[Keys["SPACE"] = 32] = "SPACE";
  Keys[Keys["DIGIT_0"] = 48] = "DIGIT_0";
  Keys[Keys["DIGIT_1"] = 49] = "DIGIT_1";
  Keys[Keys["DIGIT_2"] = 50] = "DIGIT_2";
  Keys[Keys["DIGIT_3"] = 51] = "DIGIT_3";
  Keys[Keys["DIGIT_4"] = 52] = "DIGIT_4";
  Keys[Keys["DIGIT_5"] = 53] = "DIGIT_5";
  Keys[Keys["Y"] = 89] = "Y";
  Keys[Keys["Z"] = 90] = "Z";
  Keys[Keys["COMMA"] = 188] = "COMMA";
  Keys[Keys["KEY_DOT"] = 190] = "KEY_DOT";
})(Keys || (Keys = {}));

var DialogStyles = function DialogStyles(theme) {
  return function (_props) {
    return {
      main: {
        maxHeight: '80vh',
        minHeight: '300px',
        maxWidth: '600px !important',
        minWidth: '288px',
        width: '50vw !important',
        borderRadius: '4px',
        backgroundColor: theme.palette.white,
        boxShadow: "0 2px 16px 0 " + color(theme.palette.black).alpha(0.6).rgb().string()
      }
    };
  };
};
var DialogContentStyles = function DialogContentStyles(theme) {
  return function (_props) {
    return {
      content: {
        color: theme.palette.black,
        height: '100%',
        overflowY: 'visible',
        selectors: {
          ' .ms-Dialog-inner': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '16px 24px 24px 24px',
            minHeight: DIALOG_MIN_HEIGHT - DIALOG_HEADER_HEIGHT + "px"
          }
        }
      },
      header: {
        height: DIALOG_HEADER_HEIGHT + "px",
        borderBottom: "1px solid " + theme.palette.neutralLight
      },
      title: {
        fontSize: '16px',
        fontWeight: 700,
        padding: '16px 24px'
      },
      topButton: {
        padding: '16px 16px 0 0',
        height: '40px',
        width: '40px',
        selectors: {
          '.ms-Dialog-button': {
            height: '24px',
            width: '24px',
            color: theme.palette.black,
            ' .ms-Button-icon': {
              fontWeight: 'bold',
              height: '24px',
              width: '24px',
              fontSize: '18px'
            }
          },
          '.ms-Dialog-button:hover': {
            backgroundColor: theme.palette.white
          }
        }
      },
      innerContent: {
        color: theme.palette.black,
        fontSize: '14px',
        overflowY: 'auto',
        overflowX: 'hidden'
      }
    };
  };
};
var DialogFooterStyles = function DialogFooterStyles(_theme) {
  return function (_props) {
    return {
      actions: {},
      actionsRight: {
        maxWidth: '100%',
        marginBottom: '-24px'
      }
    };
  };
};

var IconButtonStyles = function IconButtonStyles(_theme) {
  return {
    icon: {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  };
};

var Depths = {
  depth8: "0 2px 8px 0 " + /*#__PURE__*/color(palette.greyDarker).alpha(0.4).rgb().string() + ";",
  depth16: "0 2px 16px 0 " + /*#__PURE__*/color(palette.black).alpha(0.6).rgb().string() + ";"
};

var CalloutContentStyles = function CalloutContentStyles(_theme) {
  return function (_props) {
    return {
      root: {
        boxShadow: Depths.depth8
      },
      calloutMain: {
        padding: '8px 0',
        borderRadius: 0
      }
    };
  };
};

var SearchBoxStyles = function SearchBoxStyles(theme) {
  return function (props) {
    var _theme$fonts$medium;

    var hasFocus = props.hasFocus;
    return {
      root: [{
        selectors: {
          '::after': {
            borderColor: theme.palette.themePrimary,
            borderWidth: 1
          }
        }
      }, hasFocus && {
        borderColor: theme.palette.themePrimary
      }, !hasFocus && {
        borderColor: theme.palette.greyBase,
        selectors: {
          '&:hover': {
            borderColor: theme.palette.themePrimary
          }
        }
      }],
      clearButton: {
        selectors: {
          '.ms-Button': {
            color: theme.palette.black,
            selectors: {
              ':hover': {
                color: theme.palette.black
              },
              ':active': {
                color: theme.palette.black
              }
            }
          }
        }
      },
      field: {
        color: theme.palette.black
      },
      icon: {
        color: theme.palette.black,
        width: '20px',
        fontSize: (_theme$fonts$medium = theme.fonts.medium) == null ? void 0 : _theme$fonts$medium.fontSize
      }
    };
  };
};

var ToggleStyles = function ToggleStyles(theme) {
  return function (props) {
    var checked = props.checked,
        disabled = props.disabled;
    return {
      pill: [{
        background: theme.palette.greyDarker,
        selectors: {
          '&:hover .ms-Toggle-thumb': {
            background: theme.palette.white
          }
        }
      }, checked && {
        background: theme.palette.themePrimary
      }, disabled && {
        background: theme.palette.greyBase
      }],
      thumb: [{
        background: theme.palette.white,
        selectors: {
          '&:hover': {
            background: theme.palette.white
          }
        }
      }, disabled && {
        background: theme.palette.white
      }]
    };
  };
};

var DatePickerStyles = function DatePickerStyles(theme) {
  return function (_props) {
    return {
      callout: {
        selectors: {
          '.ms-DatePicker-day--today': {
            background: theme.palette.themePrimary + " !important"
          },
          '.ms-DatePicker-day--highlighted': {
            background: theme.palette.neutralLighter + " !important"
          },
          '.ms-DatePicker-goToday:not(:disabled):hover': {
            color: theme.palette.themePrimary + " !important"
          }
        }
      }
    };
  };
};

// examples: https://github.com/microsoft/fluentui/tree/master/packages/azure-themes/src/azure/styles

var componentStyles = function componentStyles(theme) {
  return {
    Checkbox: {
      styles: CheckboxStyles(theme)
    },
    DefaultButton: {
      styles: DefaultButtonStyles(theme)
    },
    PrimaryButton: {
      styles: DefaultButtonStyles(theme, true)
    },
    CommandBarButton: {
      styles: CommandBarButtonStyles(theme)
    },
    IconButton: {
      styles: IconButtonStyles()
    },
    Check: {
      styles: CheckStyles(theme)
    },
    TagPicker: {
      styles: TagPickerStyles()
    },
    TagItem: {
      styles: TagItemStyles(theme)
    },
    Dropdown: {
      styles: DropdownStyles(theme)
    },
    DatePicker: {
      styles: DatePickerStyles(theme)
    },
    SuggestionItem: {
      styles: SuggestionItemStyles(theme)
    },
    TextField: {
      styles: TextFieldStyles(theme)
    },
    Label: {
      styles: LabelStyles(theme)
    },
    DetailsList: {
      styles: DetailsListStyles(theme)
    },
    DetailsRow: {
      styles: DetailsRowStyles(theme)
    },
    ChoiceGroupOption: {
      styles: ChoiceGroupOptionStyles(theme)
    },
    Toggle: {
      styles: ToggleStyles(theme)
    },
    Dialog: {
      styles: DialogStyles(theme)
    },
    DialogContent: {
      styles: DialogContentStyles(theme)
    },
    DialogFooter: {
      styles: DialogFooterStyles()
    },
    CalloutContent: {
      styles: CalloutContentStyles()
    },
    SearchBox: {
      styles: SearchBoxStyles(theme)
    }
  };
};

var DEFAULT_FONT_FAMILY = 'Lato, sans-serif';
var DEFAULT_ICON_SIZE = 20;
var nuOrderTheme = /*#__PURE__*/createTheme({
  palette: palette,
  effects: {
    elevation4: '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)',
    roundedCorner2: '4px',
    roundedCorner4: '8px',
    roundedCorner6: '12px'
  },
  defaultFontStyle: {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSizeIcon: DEFAULT_ICON_SIZE
  }
});
var customizations = {
  settings: {
    theme: nuOrderTheme
  },
  scopedSettings: /*#__PURE__*/_extends({}, /*#__PURE__*/componentStyles(nuOrderTheme))
};

var Theme = function Theme(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Customizer, Object.assign({}, customizations), children);
};

var SvgIcon = function SvgIcon(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve"
  }, props), children);
};

var CheckboxChecked = function CheckboxChecked(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "12",
    height: "12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0z",
    transform: "translate(-102 -324) translate(91 307) translate(11 17)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    className: "checkMark",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M1.25 6.5L4.175 9.5 11 2.5",
    transform: "translate(-102 -324) translate(91 307) translate(11 17)"
  })));
};

var CheckboxIndeterminate = function CheckboxIndeterminate(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "12",
    height: "12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0z",
    transform: "translate(-102 -433) translate(91 416) translate(11 17)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M1 6L11 6",
    transform: "translate(-102 -433) translate(91 416) translate(11 17)"
  })));
};

var icon12Subset = {
  icons: {
    checkboxChecked12: /*#__PURE__*/React.createElement(CheckboxChecked, null),
    checkboxIndeterminate12: /*#__PURE__*/React.createElement(CheckboxIndeterminate, null)
  }
};

var ChevronDown = function ChevronDown(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    enableBackground: "new 0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,9.8c-0.2,0-0.4-0.1-0.5-0.2l-4-4c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0L7,7.9l3.5-3.5c0.3-0.3,0.8-0.3,1.1,0\n\ts0.3,0.8,0,1.1l-4,4C7.4,9.7,7.2,9.8,7,9.8z"
  }));
};

var ChevronLeft = function ChevronLeft(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    enableBackground: "new 0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("rect", {
    id: "_x31_4",
    fill: "none",
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,11.8c-0.2,0-0.4-0.1-0.5-0.2l-4-4c-0.3-0.3-0.3-0.8,0-1.1l4-4c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1L6.1,7l3.5,3.5\n\tc0.3,0.3,0.3,0.8,0,1.1C9.4,11.7,9.2,11.8,9,11.8z"
  }));
};

var ChevronRight = function ChevronRight(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    enableBackground: "new 0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,11.8c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1L7.9,7L4.5,3.5c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l4,4\n\tc0.3,0.3,0.3,0.8,0,1.1l-4,4C5.4,11.7,5.2,11.8,5,11.8z"
  }));
};

var ChevronUp = function ChevronUp(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    enableBackground: "new 0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,9.8c-0.2,0-0.4-0.1-0.5-0.2L7,6.1L3.5,9.5c-0.3,0.3-0.8,0.3-1.1,0s-0.3-0.8,0-1.1l4-4c0.3-0.3,0.8-0.3,1.1,0l4,4\n\tc0.3,0.3,0.3,0.8,0,1.1C11.4,9.7,11.2,9.8,11,9.8z"
  }));
};

var Ellipsis = function Ellipsis(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    enableBackground: "new 0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3,6c0.6,0,1,0.4,1,1S3.6,8,3,8S2,7.6,2,7S2.4,6,3,6z M11,6c0.6,0,1,0.4,1,1s-0.4,1-1,1\n\ts-1-0.4-1-1S10.4,6,11,6z M7,6c0.6,0,1,0.4,1,1S7.6,8,7,8S6,7.6,6,7S6.4,6,7,6z"
  }));
};

var Star = function Star(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    enableBackground: "new 0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#089E98",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "7,0.8 8.9,4.7 13.2,5.3 10.1,8.3 10.8,12.6 7,10.6 3.2,12.6 3.9,8.3 0.8,5.3 5.1,4.7 "
  }));
};

var icon14Subset = {
  icons: {
    chevronDown14: /*#__PURE__*/React.createElement(ChevronDown, null),
    chevronLeft14: /*#__PURE__*/React.createElement(ChevronLeft, null),
    chevronRight14: /*#__PURE__*/React.createElement(ChevronRight, null),
    chevronUp14: /*#__PURE__*/React.createElement(ChevronUp, null),
    ellipsis14: /*#__PURE__*/React.createElement(Ellipsis, null),
    star14: /*#__PURE__*/React.createElement(Star, null)
  }
};

var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15.8c-0.2,0-0.4-0.1-0.5-0.2l-5-5c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0L9,13.9l4.5-4.5c0.3-0.3,0.8-0.3,1.1,0\n\ts0.3,0.8,0,1.1l-5,5C9.4,15.7,9.2,15.8,9,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15.8c-0.4,0-0.8-0.3-0.8-0.8V3c0-0.4,0.3-0.8,0.8-0.8S9.8,2.6,9.8,3v12C9.8,15.4,9.4,15.8,9,15.8z"
  }));
};

var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8.8c-0.2,0-0.4-0.1-0.5-0.2L9,4.1L4.5,8.5c-0.3,0.3-0.8,0.3-1.1,0s-0.3-0.8,0-1.1l5-5c0.3-0.3,0.8-0.3,1.1,0l5,5\n\tc0.3,0.3,0.3,0.8,0,1.1C14.4,8.7,14.2,8.8,14,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15.8c-0.4,0-0.8-0.3-0.8-0.8V3c0-0.4,0.3-0.8,0.8-0.8S9.8,2.6,9.8,3v12C9.8,15.4,9.4,15.8,9,15.8z"
  }));
};

var BellOff = function BellOff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "0,18 18,18 18,0 0,0 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,13.8H2c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h11c0.4,0,0.8,0.3,0.8,0.8S13.4,13.8,13,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,9.8c-0.4,0-0.8-0.3-0.8-0.8c0-3.4-2.5-4.3-2.5-4.3c-0.3-0.1-0.5-0.4-0.5-0.7c0-0.3-0.1-1.2-1.2-1.2\n\tC8.4,2.8,8.2,3,7.9,3.4c0,0-0.5,0.3-1-0.1C6.5,3,6.7,2.5,6.7,2.5C7,2.1,7.7,1.2,9,1.2c1.7,0,2.5,1.2,2.7,2.2c1,0.5,3,2,3,5.5\n\tC14.8,9.4,14.4,9.8,14,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,13.8c-0.4,0-0.8-0.3-0.8-0.8V9c0-2.2,1-3.3,1.5-3.9L4.9,5c0.3-0.3,0.7-0.4,1.1-0.1C6.2,5.2,6.3,5.6,6,5.9L5.9,6.1\n\tC5.4,6.6,4.8,7.4,4.8,9v4C4.8,13.4,4.4,13.8,4,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16.8c-2,0-2.8-1.6-2.8-2.8v-1c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v1c0,0.3,0.1,1.2,1.2,1.2c1.1,0,1.2-1,1.2-1.3v-1\n\tc0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v1C11.8,15.1,11,16.8,9,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,17.8c-0.2,0-0.4-0.1-0.5-0.2l-16-16c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l16,16c0.3,0.3,0.3,0.8,0,1.1\n\tC17.4,17.7,17.2,17.8,17,17.8z"
  }));
};

var Filter = function Filter(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,16.8c-0.1,0-0.3,0-0.4-0.1l-2.8-1.6C7,15,6.9,14.7,6.9,14.4V9.6L1.4,2.5C1.2,2.2,1.2,1.9,1.3,1.7S1.7,1.2,2,1.2h14\n\tc0.3,0,0.5,0.2,0.7,0.4c0.1,0.3,0.1,0.6-0.1,0.8l-5.4,7.2V16c0,0.3-0.1,0.5-0.4,0.6C10.7,16.7,10.5,16.8,10.4,16.8z M8.4,14l1.3,0.7\n\tV9.4c0-0.2,0.1-0.3,0.2-0.5l4.7-6.2h-11l4.7,6.2C8.3,9,8.4,9.2,8.4,9.4V14z"
  }));
};

var MagGlass = function MagGlass(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2,13.2c-3.3,0-6-2.7-6-6s2.7-6,6-6c3.3,0,6,2.7,6,6S11.5,13.2,8.2,13.2z M8.2,2.8c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5\n\tc2.5,0,4.5-2,4.5-4.5S10.7,2.8,8.2,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4,16.2c-0.2,0-0.4-0.1-0.5-0.2l-3.8-3.8c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l3.8,3.8c0.3,0.3,0.3,0.8,0,1.1\n\tC15.8,16.1,15.6,16.2,15.4,16.2z"
  }));
};

var Merchant = function Merchant(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,17.2H3c-1.5,0-2.8-1.2-2.8-2.8v-11C0.2,2,1.5,0.8,3,0.8h12c1.5,0,2.8,1.2,2.8,2.8v11C17.8,16,16.5,17.2,15,17.2z M3,2.2\n\tc-0.7,0-1.2,0.6-1.2,1.2v11c0,0.7,0.6,1.2,1.2,1.2h12c0.7,0,1.2-0.6,1.2-1.2v-11c0-0.7-0.6-1.2-1.2-1.2H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,14.2c-0.4,0-0.8-0.3-0.8-0.8v-1c0-0.7-0.6-1.2-1.2-1.2h-4c-0.7,0-1.2,0.6-1.2,1.2v1c0,0.4-0.3,0.8-0.8,0.8\n\ts-0.8-0.3-0.8-0.8v-1C2.8,11,4,9.8,5.5,9.8h4c1.5,0,2.8,1.2,2.8,2.8v1C12.2,13.9,11.9,14.2,11.5,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,9.2C6,9.2,4.8,8,4.8,6.5S6,3.8,7.5,3.8s2.8,1.2,2.8,2.8S9,9.2,7.5,9.2z M7.5,5.2c-0.7,0-1.2,0.6-1.2,1.2\n\ts0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S8.2,5.2,7.5,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,14.2c-0.4,0-0.8-0.3-0.8-0.8v-1c0-0.6-0.4-1.1-0.9-1.2c-0.4-0.1-0.6-0.5-0.5-0.9c0.1-0.4,0.5-0.6,0.9-0.5\n\tc1.2,0.3,2.1,1.4,2.1,2.7v1C15.2,13.9,14.9,14.2,14.5,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,9.2c-0.3,0-0.6-0.2-0.7-0.6c-0.1-0.4,0.1-0.8,0.5-0.9c0.6-0.1,0.9-0.6,0.9-1.2s-0.4-1.1-0.9-1.2\n\tc-0.4-0.1-0.6-0.5-0.5-0.9c0.1-0.4,0.5-0.6,0.9-0.5c1.2,0.3,2.1,1.4,2.1,2.7s-0.9,2.4-2.1,2.7C11.1,9.2,11.1,9.2,11,9.2z"
  }));
};

var MyDrive = function MyDrive(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,17.2H3c-1.5,0-2.8-1.2-2.8-2.8v-11C0.2,2,1.5,0.8,3,0.8h12c1.5,0,2.8,1.2,2.8,2.8v11C17.8,16,16.5,17.2,15,17.2z M3,2.2\n\tc-0.7,0-1.2,0.6-1.2,1.2v11c0,0.7,0.6,1.2,1.2,1.2h12c0.7,0,1.2-0.6,1.2-1.2v-11c0-0.7-0.6-1.2-1.2-1.2H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,14.2H4.9c-1,0-1.9-0.8-1.9-1.9V5.6c0-1,0.8-1.9,1.9-1.9h2.8c0.2,0,0.4,0.1,0.6,0.3l1.1,1.2h3.8c1,0,1.9,0.8,1.9,1.9\n\tv5.2C15,13.4,14.2,14.2,13.1,14.2z M4.9,5.2c-0.2,0-0.4,0.2-0.4,0.4v6.8c0,0.2,0.2,0.4,0.4,0.4h8.2c0.2,0,0.4-0.2,0.4-0.4V7.1\n\tc0-0.2-0.2-0.4-0.4-0.4H9c-0.2,0-0.4-0.1-0.6-0.3L7.3,5.2H4.9z"
  }));
};

var Plus = function Plus(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,14.8c-0.4,0-0.8-0.3-0.8-0.8V4c0-0.4,0.3-0.8,0.8-0.8S9.8,3.6,9.8,4v10C9.8,14.4,9.4,14.8,9,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,9.8H4C3.6,9.8,3.2,9.4,3.2,9S3.6,8.2,4,8.2h10c0.4,0,0.8,0.3,0.8,0.8S14.4,9.8,14,9.8z"
  }));
};

var User = function User(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,16.5c-0.4,0-0.8-0.3-0.8-0.8v-1.5c0-1.2-1-2.2-2.2-2.2H6c-1.2,0-2.2,1-2.2,2.2v1.5c0,0.4-0.3,0.8-0.8,0.8\n\ts-0.8-0.3-0.8-0.8v-1.5c0-2.1,1.7-3.8,3.8-3.8h6c2.1,0,3.8,1.7,3.8,3.8v1.5C15.8,16.2,15.4,16.5,15,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9C6.9,9,5.2,7.3,5.2,5.2S6.9,1.5,9,1.5c2.1,0,3.8,1.7,3.8,3.8S11.1,9,9,9z M9,3C7.8,3,6.8,4,6.8,5.2s1,2.2,2.2,2.2\n\tc1.2,0,2.2-1,2.2-2.2S10.2,3,9,3z"
  }));
};

var Users = function Users(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,15.8c-0.4,0-0.8-0.3-0.8-0.8v-1.4c0-1.2-1-2.1-2.2-2.1H3.9c-1.2,0-2.2,1-2.2,2.1V15c0,0.4-0.3,0.8-0.8,0.8\n\tS0.2,15.4,0.2,15v-1.4c0-2,1.6-3.6,3.7-3.6h5.8c2,0,3.7,1.6,3.7,3.6V15C13.4,15.4,13.1,15.8,12.6,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,8.5c-2,0-3.7-1.6-3.7-3.6c0-2,1.6-3.6,3.7-3.6s3.7,1.6,3.7,3.6C10.5,6.9,8.8,8.5,6.8,8.5z M6.8,2.8\n\tc-1.2,0-2.2,1-2.2,2.1c0,1.2,1,2.1,2.2,2.1S9,6.1,9,4.9C9,3.7,8,2.8,6.8,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,15.8c-0.4,0-0.8-0.3-0.8-0.8v-1.4c0-1-0.7-1.8-1.6-2.1c-0.4-0.1-0.6-0.5-0.5-0.9c0.1-0.4,0.5-0.6,0.9-0.5\n\tc1.6,0.4,2.7,1.9,2.7,3.5V15C17.8,15.4,17.4,15.8,17,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,8.4c-0.3,0-0.6-0.2-0.7-0.6c-0.1-0.4,0.1-0.8,0.5-0.9c1-0.2,1.6-1.1,1.6-2.1c0-1-0.7-1.8-1.6-2.1\n\tc-0.4-0.1-0.6-0.5-0.5-0.9c0.1-0.4,0.5-0.6,0.9-0.5c1.6,0.4,2.8,1.9,2.8,3.5c0,1.7-1.1,3.1-2.8,3.5C12,8.4,12,8.4,11.9,8.4z"
  }));
};

var Rollup = function Rollup(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 9.000000) scale(-1, 1) translate(-9.000000, -9.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("g", {
    className: "fu-icon",
    transform: "translate(1.875000, 0.750000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.625000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1875,1.125 L7.21875,1.125 C7.78829365,1.125 8.25,1.59137005 8.25,2.16666667 L8.25,9.45833333 C8.25,10.0336299 7.78829365,10.5 7.21875,10.5 L1.03125,10.5 C0.461706352,10.5 6.66133815e-16,10.0336299 6.66133815e-16,9.45833333 L6.66133815e-16,2.16666667 C6.66133815e-16,1.59137005 0.461706352,1.125 1.03125,1.125 L2.0625,1.125"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2.25",
    y: "0",
    width: "3.75",
    height: "2.25",
    rx: "1"
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(4.125000, 6.000000) scale(-1, 1) translate(-4.125000, -6.000000) ",
    points: "6 4.5 3.65625 7.5 2.25 6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,11.25 L11.25,12.4583333 C11.25,13.0336299 10.7882936,13.5 10.21875,13.5 L4.03125,13.5 C3.46170635,13.5 3,13.0336299 3,12.4583333 L3,5.16666667 C3,4.59137005 3.46170635,4.125 4.03125,4.125 L5.25,4.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,14.25 L8.25,15.4583333 C8.25,16.0336299 7.78829365,16.5 7.21875,16.5 L1.03125,16.5 C0.461706352,16.5 0,16.0336299 0,15.4583333 L0,8.16666667 C0,7.59137005 0.461706352,7.125 1.03125,7.125 L2.25,7.125"
  })))));
};

var Trash = function Trash(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,3.8h-3V3c0-1.2-1-2.2-2.2-2.2h-3c-1.2,0-2.2,1-2.2,2.2v0.8h-3c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8H3V15\n\t\tc0,1.2,1,2.2,2.2,2.2h7.5c1.2,0,2.2-1,2.2-2.2V5.2h0.8c0.4,0,0.8-0.3,0.8-0.8S16.2,3.8,15.8,3.8z M6.8,3c0-0.4,0.3-0.8,0.8-0.8h3\n\t\tc0.4,0,0.8,0.3,0.8,0.8v0.8H6.8V3z M13.5,15c0,0.4-0.3,0.8-0.8,0.8H5.2c-0.4,0-0.8-0.3-0.8-0.8V5.2h9V15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,7.5c-0.4,0-0.8,0.3-0.8,0.8v4.5c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V8.2C8.2,7.8,7.9,7.5,7.5,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,7.5c-0.4,0-0.8,0.3-0.8,0.8v4.5c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V8.2C11.2,7.8,10.9,7.5,10.5,7.5z"
  })));
};

var Star$1 = function Star(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#585858",
    "data-color": "stroke",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "9 1 11.472 6.008 17 6.816 13 10.712 13.944 16.216 9 13.616 4.056 16.216 5 10.712 1 6.816 6.528 6.008"
  })))))));
};

var Home = function Home(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,16.8H4.3c-1.1,0-2.1-1-2.1-2.2V6.9c0-0.2,0.1-0.4,0.3-0.6l6-4.9c0.3-0.2,0.7-0.2,0.9,0l6,4.9c0.2,0.1,0.3,0.4,0.3,0.6\n\tv7.7C15.8,15.8,14.8,16.8,13.7,16.8z M3.8,7.3v7.3c0,0.4,0.3,0.7,0.6,0.7h9.3c0.3,0,0.6-0.3,0.6-0.7V7.3L9,3L3.8,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,16.8c-0.4,0-0.8-0.3-0.8-0.8V9.8H7.8V16c0,0.4-0.3,0.8-0.8,0.8S6.2,16.4,6.2,16V9c0-0.4,0.3-0.8,0.8-0.8h4\n\tc0.4,0,0.8,0.3,0.8,0.8v7C11.8,16.4,11.4,16.8,11,16.8z"
  }));
};

var icon18Subset = {
  icons: {
    arrowDown18: /*#__PURE__*/React.createElement(ArrowDown, null),
    arrowUp18: /*#__PURE__*/React.createElement(ArrowUp, null),
    bellOff18: /*#__PURE__*/React.createElement(BellOff, null),
    filter18: /*#__PURE__*/React.createElement(Filter, null),
    home18: /*#__PURE__*/React.createElement(Home, null),
    magGlass18: /*#__PURE__*/React.createElement(MagGlass, null),
    merchant18: /*#__PURE__*/React.createElement(Merchant, null),
    myDrive18: /*#__PURE__*/React.createElement(MyDrive, null),
    plus18: /*#__PURE__*/React.createElement(Plus, null),
    user18: /*#__PURE__*/React.createElement(User, null),
    users18: /*#__PURE__*/React.createElement(Users, null),
    rollup18: /*#__PURE__*/React.createElement(Rollup, null),
    trash18: /*#__PURE__*/React.createElement(Trash, null),
    star18: /*#__PURE__*/React.createElement(Star$1, null)
  }
};

var AlertCircle = function AlertCircle(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9\n\tC21,7,17,3,12,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1s1,0.4,1,1v4C13,12.6,12.6,13,12,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,17c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S12.6,17,12,17z"
  }));
};

var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,11H7.4l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-7,7c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.2-0.1,0.5,0,0.8\n\tc0.1,0.1,0.1,0.2,0.2,0.3l7,7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L7.4,13H19c0.6,0,1-0.4,1-1\n\tS19.6,11,19,11z"
  }));
};

var Assortment = function Assortment(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 25",
    enableBackground: "new 0 0 24 25"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2,23.5H5.8c-1.7,0-3.1-1.4-3.1-3.1V5.7c0-1.7,1.4-3.1,3.1-3.1h2.1c0.6,0,1,0.4,1,1s-0.4,1-1,1H5.8\n\tc-0.6,0-1.1,0.5-1.1,1.1v14.7c0,0.6,0.5,1.1,1.1,1.1h12.4c0.6,0,1.1-0.5,1.1-1.1V5.7c0-0.6-0.5-1.1-1.1-1.1h-2.1c-0.6,0-1-0.4-1-1\n\ts0.4-1,1-1h2.1c1.7,0,3.1,1.4,3.1,3.1v14.7C21.2,22.1,19.9,23.5,18.2,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,6.7H8.9c-1.1,0-2-0.9-2-2V2.5c0-1.1,0.9-2,2-2h6.2c1.1,0,2,0.9,2,2v2.2C17.1,5.8,16.2,6.7,15.1,6.7z M8.9,2.5L8.9,2.5\n\tv2.2h6.2V2.5H8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,18.2c-0.3,0-0.5-0.1-0.7-0.3l-3.1-3.2c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l2.3,2.4l4.5-5.4c0.3-0.4,1-0.5,1.4-0.1\n\tc0.4,0.4,0.5,1,0.1,1.4l-5.2,6.3C11.6,18.1,11.3,18.2,11,18.2C11,18.2,11,18.2,11,18.2z"
  }));
};

var Bell = function Bell(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "0,24 24,24 24,0 0,0 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,19H3c-0.6,0-1-0.4-1-1s0.4-1,1-1h18c0.6,0,1,0.4,1,1S21.6,19,21,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,19c-0.6,0-1-0.4-1-1v-7c0-4.2-3.2-5-3.2-5L14,5.8V5c0-0.5-0.2-2-2-2c-1.9,0-2,1.7-2,2v0.8L9.2,6C9.1,6,6,6.9,6,12v6\n\tc0,0.6-0.4,1-1,1s-1-0.4-1-1v-6c0-5.2,2.7-7.1,4.1-7.7C8.3,2.8,9.5,1,12,1c2.5,0,3.7,1.8,3.9,3.3C17.6,5,20,7,20,11v7\n\tC20,18.6,19.6,19,19,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23c-2.9,0-4-2.4-4-4v-1c0-0.6,0.4-1,1-1s1,0.4,1,1v1c0,0.5,0.2,2,2,2c1.9,0,2-1.7,2-2v-1c0-0.6,0.4-1,1-1s1,0.4,1,1v1\n\tC16,20.6,14.9,23,12,23z"
  }));
};

var Clear = function Clear(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0F0F0",
    cx: "12",
    cy: "12",
    r: "12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#585858",
    d: "M0,8.8c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l8-8c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1l-8,8\n\t\tC0.4,8.7,0.2,8.8,0,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585858",
    d: "M8,8.8c-0.2,0-0.4-0.1-0.5-0.2l-8-8c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l8,8c0.3,0.3,0.3,0.8,0,1.1\n\t\tC8.4,8.7,8.2,8.8,8,8.8z"
  })));
};

var Close = function Close(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,19c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l12-12c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-12,12C6.5,18.9,6.3,19,6,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19c-0.3,0-0.5-0.1-0.7-0.3l-12-12c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l12,12c0.4,0.4,0.4,1,0,1.4C18.5,18.9,18.3,19,18,19\n\tz"
  }));
};

var Eye = function Eye(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(1.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,17C3.5,17-0.7,8.8-0.9,8.4C-1,8.2-1,7.8-0.9,7.6C-0.7,7.2,3.5-1,11-1s11.7,8.2,11.9,8.6c0.1,0.3,0.1,0.6,0,0.9\n\t\tC22.7,8.8,18.5,17,11,17z M1.1,8c0.9,1.6,4.5,7,9.9,7c5.4,0,8.9-5.4,9.9-7c-0.9-1.6-4.5-7-9.9-7C5.6,1,2.1,6.4,1.1,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,12c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4C15,10.2,13.2,12,11,12z M11,6C9.9,6,9,6.9,9,8c0,1.1,0.9,2,2,2\n\t\tc1.1,0,2-0.9,2-2C13,6.9,12.1,6,11,6z"
  })));
};

var FolderShared = function FolderShared(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,22H4c-1.7,0-3-1.3-3-3V5c0-1.7,1.3-3,3-3h5c0.3,0,0.6,0.2,0.8,0.4L11.5,5H20c1.7,0,3,1.3,3,3v11C23,20.7,21.7,22,20,22z\n            M4,4C3.4,4,3,4.4,3,5v14c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8c0-0.6-0.4-1-1-1h-9c-0.3,0-0.6-0.2-0.8-0.4L8.5,4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,19c-0.6,0-1-0.4-1-1c0-0.6-0.4-1-1-1H8c-0.6,0-1,0.4-1,1c0,0.6-0.4,1-1,1s-1-0.4-1-1c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3\n            C15,18.6,14.6,19,14,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,14c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S11.7,14,10,14z M10,10c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S10.6,10,10,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,19c-0.6,0-1-0.4-1-1c0-0.5-0.3-0.9-0.8-1c-0.5-0.1-0.9-0.7-0.7-1.2c0.1-0.5,0.7-0.8,1.2-0.7c1.3,0.3,2.2,1.6,2.2,2.9\n            C19.5,18.5,19.1,19,18.5,19L18.5,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14c-0.4,0-0.8-0.3-1-0.7c-0.1-0.5,0.2-1.1,0.7-1.2c0.4-0.1,0.8-0.5,0.8-1s-0.3-0.9-0.8-1c-0.5-0.1-0.9-0.7-0.7-1.2\n            c0.1-0.5,0.7-0.9,1.2-0.7c1.3,0.4,2.2,1.6,2.2,3s-0.9,2.6-2.2,3C15.2,14,15.1,14,15,14z"
  }));
};

var Folder = function Folder(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,22H4c-1.7,0-3-1.3-3-3V5c0-1.7,1.3-3,3-3h5c0.3,0,0.6,0.2,0.8,0.4L11.5,5H20c1.7,0,3,1.3,3,3v11C23,20.7,21.7,22,20,22z\n\t M4,4C3.4,4,3,4.4,3,5v14c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8c0-0.6-0.4-1-1-1h-9c-0.3,0-0.6-0.2-0.8-0.4L8.5,4H4z"
  }));
};

var Hamburger = function Hamburger(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,8H0c-0.6,0-1-0.4-1-1s0.4-1,1-1h18c0.6,0,1,0.4,1,1S18.6,8,18,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,2H0c-0.6,0-1-0.4-1-1s0.4-1,1-1h18c0.6,0,1,0.4,1,1S18.6,2,18,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,14H0c-0.6,0-1-0.4-1-1s0.4-1,1-1h18c0.6,0,1,0.4,1,1S18.6,14,18,14z"
  })));
};

var HorizKabob = function HorizKabob(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18,10c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S16.9,10,18,10z M12,10c1.1,0,2,0.9,2,2\n\ts-0.9,2-2,2s-2-0.9-2-2S10.9,10,12,10z M6,10c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S4.9,10,6,10z"
  }));
};

var InfoHover = function InfoHover(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: "12",
    cy: "12",
    r: "12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585858",
    d: "M12,18c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v5C13,17.6,12.6,18,12,18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585858",
    d: "M12,9c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S12.6,9,12,9z"
  }));
};

var Merchant$1 = function Merchant(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    fillRule: "evenodd",
    clipRule: "eventodd",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23H3c-1.7,0-3-1.3-3-3V4c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3v16C24,21.7,22.7,23,21,23z M3,3C2.4,3,2,3.4,2,4v16\n\tc0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V4c0-0.6-0.4-1-1-1H3z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "16",
    height: "16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,15c-0.6,0-1-0.4-1-1v-1.3c0-0.9-0.7-1.7-1.7-1.7H3.3c-0.9,0-1.7,0.7-1.7,1.7V14c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1.3\n\t\tc0-2,1.6-3.7,3.7-3.7h5.3c2,0,3.7,1.6,3.7,3.7V14C12.3,14.6,11.9,15,11.3,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8.3c-2,0-3.7-1.6-3.7-3.7C2.3,2.6,4,1,6,1s3.7,1.6,3.7,3.7C9.7,6.7,8,8.3,6,8.3z M6,3C5.1,3,4.3,3.7,4.3,4.7\n\t\tS5.1,6.3,6,6.3s1.7-0.7,1.7-1.7S6.9,3,6,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,15c-0.6,0-1-0.4-1-1v-1.3c0-0.8-0.5-1.4-1.2-1.6c-0.5-0.1-0.9-0.7-0.7-1.2C12.5,9.3,13,9,13.6,9.1\n\t\tc1.6,0.4,2.7,1.9,2.8,3.5V14C16.3,14.6,15.9,15,15.3,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,8.3c-0.4,0-0.9-0.3-1-0.8C9.6,7,9.9,6.4,10.4,6.3c0.7-0.2,1.3-0.9,1.3-1.6s-0.5-1.4-1.3-1.6C9.9,2.9,9.6,2.4,9.7,1.8\n\t\tc0.1-0.5,0.7-0.9,1.2-0.7c1.6,0.4,2.8,1.9,2.8,3.6s-1.1,3.1-2.8,3.6C10.8,8.2,10.7,8.3,10.7,8.3z"
  })));
};

var MyDrive$1 = function MyDrive(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,1H3C1.3,1,0,2.3,0,4v16c0,1.7,1.3,3,3,3h18c1.7,0,3-1.3,3-3V4C24,2.3,22.7,1,21,1z M22,20c0,0.6-0.4,1-1,1H3\n\t\tc-0.6,0-1-0.4-1-1V4c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1V20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,7h-5L11,5.3C10.8,5.1,10.5,5,10.2,5H6.5C5.1,5,4,6.1,4,7.5v9C4,17.9,5.1,19,6.5,19h11c1.4,0,2.5-1.1,2.5-2.5v-7\n\t\tC20,8.1,18.9,7,17.5,7z M18,16.5c0,0.3-0.2,0.5-0.5,0.5h-11C6.2,17,6,16.8,6,16.5v-9C6,7.2,6.2,7,6.5,7h3.3l1.5,1.7\n\t\tC11.4,8.9,11.7,9,12,9h5.5C17.8,9,18,9.2,18,9.5V16.5z"
  })));
};

var Pencil = function Pencil(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,22H3c-0.6,0-1-0.4-1-1v-5c0-0.3,0.1-0.5,0.3-0.7l13-13c0.4-0.4,1-0.4,1.4,0l5,5c0.4,0.4,0.4,1,0,1.4l-13,13\n\tC8.5,21.9,8.3,22,8,22z M4,20h3.6l12-12L16,4.4l-12,12V20z"
  }));
};

var Plus$1 = function Plus(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,13H5c-0.6,0-1-0.4-1-1s0.4-1,1-1h14c0.6,0,1,0.4,1,1S19.6,13,19,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1s1,0.4,1,1v14C13,19.6,12.6,20,12,20z"
  }));
};

var Timer = function Timer(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,22.5c-5,0-9-4-9-9c0-5,4-9,9-9c5,0,9,4,9,9C20.5,18.5,16.5,22.5,11.5,22.5z M11.5,6.5c-3.9,0-7,3.1-7,7\n\tc0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C18.5,9.6,15.4,6.5,11.5,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,3.5h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S14.1,3.5,13.5,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,6.5c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1s1,0.4,1,1v3C12.5,6.1,12.1,6.5,11.5,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,14.5c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v4C12.5,14.1,12.1,14.5,11.5,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,9.1c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l2.1-2.1c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-2.1,2.1\n\tC18,9,17.7,9.1,17.4,9.1z"
  }));
};

var Trash$1 = function Trash(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,7H3C2.4,7,2,6.6,2,6s0.4-1,1-1h18c0.6,0,1,0.4,1,1S21.6,7,21,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,23H7c-1.7,0-3-1.3-3-3V6c0-0.6,0.4-1,1-1s1,0.4,1,1v14c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V6c0-0.6,0.4-1,1-1s1,0.4,1,1\n\tv14C20,21.7,18.7,23,17,23z M16,7c-0.6,0-1-0.4-1-1V4c0-0.6-0.4-1-1-1h-4C9.4,3,9,3.4,9,4v2c0,0.6-0.4,1-1,1S7,6.6,7,6V4\n\tc0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v2C17,6.6,16.6,7,16,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,18c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1s1,0.4,1,1v6C11,17.6,10.6,18,10,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1s1,0.4,1,1v6C15,17.6,14.6,18,14,18z"
  }));
};

var UserPlus = function UserPlus(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,22c-0.6,0-1-0.4-1-1v-2c0-1.7-1.3-3-3-3H5c-1.7,0-3,1.3-3,3v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2c0-2.8,2.2-5,5-5h7\n\tc2.8,0,5,2.2,5,5v2C17,21.6,16.6,22,16,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,12c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S11.3,12,8.5,12z M8.5,4c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S10.2,4,8.5,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,15c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1s1,0.4,1,1v6C21,14.6,20.6,15,20,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,12h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S23.6,12,23,12z"
  }));
};

var User$1 = function User(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,22c-0.6,0-1-0.4-1-1v-2c0-1.7-1.3-3-3-3H8c-1.7,0-3,1.3-3,3v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2c0-2.8,2.2-5,5-5h8\n\tc2.8,0,5,2.2,5,5v2C21,21.6,20.6,22,20,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S14.8,12,12,12z M12,4c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.7,4,12,4z"
  }));
};

var Users$1 = function Users(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,14H5c-2.8,0-5,2.2-5,5v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2c0-1.7,1.3-3,3-3h8c1.7,0,3,1.3,3,3v2c0,0.6,0.4,1,1,1s1-0.4,1-1\n\t\tv-2C18,16.2,15.8,14,13,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,12c2.8,0,5-2.2,5-5s-2.2-5-5-5S4,4.2,4,7S6.2,12,9,12z M9,4c1.7,0,3,1.3,3,3s-1.3,3-3,3S6,8.7,6,7S7.3,4,9,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2,14.2c-0.5-0.1-1.1,0.2-1.2,0.7c-0.1,0.5,0.2,1.1,0.7,1.2c1.3,0.3,2.2,1.5,2.2,2.9v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2\n\t\tC24,16.7,22.5,14.7,20.2,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,2.2C15.7,2,15.2,2.3,15,2.9c-0.1,0.5,0.2,1.1,0.7,1.2C17.1,4.4,18,5.6,18,7s-0.9,2.6-2.3,2.9\n\t\tc-0.5,0.1-0.9,0.7-0.7,1.2c0.1,0.5,0.5,0.8,1,0.8c0.1,0,0.2,0,0.2,0C18.5,11.3,20,9.3,20,7S18.5,2.7,16.2,2.2z"
  }));
};

var Whiteboard = function Whiteboard(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,5H2C1.4,5,1,4.6,1,4s0.4-1,1-1h20c0.6,0,1,0.4,1,1S22.6,5,22,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,18H2c-0.6,0-1-0.4-1-1s0.4-1,1-1h20c0.6,0,1,0.4,1,1S22.6,18,22,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,18H3c-0.6,0-1-0.4-1-1V4c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1v13C22,17.6,21.6,18,21,18z M4,16h16V5H4V16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v5C13,22.6,12.6,23,12,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1s1,0.4,1,1v2C13,4.6,12.6,5,12,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,23c-0.3,0-0.5-0.1-0.7-0.3L12,18.4l-4.3,4.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0l5,5\n\tc0.4,0.4,0.4,1,0,1.4C17.5,22.9,17.3,23,17,23z"
  }));
};

var Rollup$1 = function Rollup(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    className: "fu-icon",
    transform: "translate(2.500000, 1.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,1.5 L9.625,1.5 C10.3843915,1.5 11,2.12182674 11,2.88888889 L11,12.6111111 C11,13.3781733 10.3843915,14 9.625,14 L1.375,14 C0.615608469,14 8.8817842e-16,13.3781733 8.8817842e-16,12.6111111 L8.8817842e-16,2.88888889 C8.8817842e-16,2.12182674 0.615608469,1.5 1.375,1.5 L2.75,1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "0",
    width: "5",
    height: "3",
    rx: "1"
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(5.500000, 8.000000) scale(-1, 1) translate(-5.500000, -8.000000) ",
    points: "8 6 4.875 10 3 8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,15 L15,16.6111111 C15,17.3781733 14.3843915,18 13.625,18 L5.375,18 C4.61560847,18 4,17.3781733 4,16.6111111 L4,6.88888889 C4,6.12182674 4.61560847,5.5 5.375,5.5 L7,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,19 L11,20.6111111 C11,21.3781733 10.3843915,22 9.625,22 L1.375,22 C0.615608469,22 0,21.3781733 0,20.6111111 L0,10.8888889 C0,10.1218267 0.615608469,9.5 1.375,9.5 L3,9.5"
  })))));
};

var ShortcutAssortment = function ShortcutAssortment(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.750000, 1.500000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375,2.1 L14.4375,2.1 C15.5765873,2.1 16.5,3.04020203 16.5,4.2 L16.5,18.9 C16.5,20.059798 15.5765873,21 14.4375,21 L2.0625,21 C0.923412703,21 0,20.059798 0,18.9 L0,4.2 C0,3.04020203 0.923412703,2.1 2.0625,2.1 L4.125,2.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "4.125",
    y: "0",
    width: "8.25",
    height: "4.2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.375 9.45 7.21875 15.75 4.125 12.6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "13",
    height: "13"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 5.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 0 7 0 7 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "7",
    y1: "0",
    x2: "0",
    y2: "7"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "13",
    height: "13"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 6.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 0 6 0 6 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "6",
    y1: "0",
    x2: "0",
    y2: "6"
  }))))));
};

var ShortcutFolder = function ShortcutFolder(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 3.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,16 C20,17.1045695 19.1045695,18 18,18 L2,18 C0.8954305,18 0,17.1045695 0,16 L0,2 C0,0.8954305 0.8954305,0 2,0 L7,0 L9,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,16 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "13",
    height: "13"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 5.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 0 7 0 7 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "7",
    y1: "0",
    x2: "0",
    y2: "7"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "13",
    height: "13"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 6.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 0 6 0 6 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "6",
    y1: "0",
    x2: "0",
    y2: "6"
  }))))));
};

var ShortcutRollup = function ShortcutRollup(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.500000, 1.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,1.5 L9.625,1.5 C10.3843915,1.5 11,2.12182674 11,2.88888889 L11,12.6111111 C11,13.3781733 10.3843915,14 9.625,14 L1.375,14 C0.615608469,14 8.8817842e-16,13.3781733 8.8817842e-16,12.6111111 L8.8817842e-16,2.88888889 C8.8817842e-16,2.12182674 0.615608469,1.5 1.375,1.5 L2.75,1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "0",
    width: "5",
    height: "3",
    rx: "1"
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(5.500000, 8.000000) scale(-1, 1) translate(-5.500000, -8.000000) ",
    points: "8 6 4.875 10 3 8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,15 L15,16.6111111 C15,17.3781733 14.3843915,18 13.625,18 L5.375,18 C4.61560847,18 4,17.3781733 4,16.6111111 L4,6.88888889 C4,6.12182674 4.61560847,5.5 5.375,5.5 L7,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,19 L11,20.6111111 C11,21.3781733 10.3843915,22 9.625,22 L1.375,22 C0.615608469,22 0,21.3781733 0,20.6111111 L0,10.8888889 C0,10.1218267 0.615608469,9.5 1.375,9.5 L3,9.5"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "13",
    height: "13"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 6.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 0 6 0 6 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "6",
    y1: "0",
    x2: "0",
    y2: "6"
  })))));
};

var ShortcutWhiteboard = function ShortcutWhiteboard(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "0",
    y1: "2",
    x2: "20",
    y2: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "0",
    y1: "15",
    x2: "20",
    y2: "15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "2",
    width: "18",
    height: "13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "10",
    y1: "15",
    x2: "10",
    y2: "20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "10",
    y1: "0",
    x2: "10",
    y2: "2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 20 10 15 5 20"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "13",
    height: "13"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 6.000000)",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 0 6 0 6 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "6",
    y1: "0",
    x2: "0",
    y2: "6"
  }))))));
};

var Star$2 = function Star(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-248.000000, -138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(248.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#585858",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "12 1.33333333 15.296 8.01066667 22.6666667 9.088 17.3333333 14.2826667 18.592 21.6213333 12 18.1546667 5.408 21.6213333 6.66666667 14.2826667 1.33333333 9.088 8.704 8.01066667"
  }))))));
};

var ChevronDown$1 = function ChevronDown(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-352.000000, -746.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 728.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#2D2D2D",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(12.000000, 12.000000) rotate(270.000000) translate(-12.000000, -12.000000) ",
    points: "15.4285714 18.8571429 8.57142857 12 15.4285714 5.14285714"
  })))))));
};

var ChevronUp$1 = function ChevronUp(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-352.000000, -413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 395.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#2D2D2D",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "5 15.5 12 8.5 19 15.5"
  })))))));
};

var Success = function Success(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.000000, -473.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 395.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#00A9A4",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#00A9A4",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "17 9 10.4375 16 7 12.3636364"
  })))))));
};

var Globe = function Globe(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h18v18H3z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8h16M8 0a12.24 12.24 0 013.2 8A12.24 12.24 0 018 16a12.24 12.24 0 01-3.2-8A12.24 12.24 0 018 0h0z"
  }))));
};

var Facebook = function Facebook(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 5.1h1.9V2h-2.3c-3.7.1-4.4 2.2-4.5 4.4v2.5H8V12h1.9v10h3.8V12h2.8l.5-3.1h-3.4V6.6c0-.7.5-1.5 1.2-1.5"
  }));
};

var Linkedin = function Linkedin(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.977 20H9.72V9.31h3.114v1.38h.072c0-.072.072-.072.072-.145.58-.872 1.448-1.381 2.462-1.527a4.381 4.381 0 012.534.291c.941.364 1.448 1.164 1.737 2.11.218.8.29 1.672.29 2.472v5.964h-3.258v-5.746c0-.364-.072-.8-.145-1.164-.145-.654-.579-1.018-1.23-1.09-.724-.073-1.304 0-1.81.581-.29.364-.362.8-.435 1.237 0 .29-.072.582-.072.872v5.019c-.073.29-.073.363-.073.436zM4.29 20V9.31h3.258V20H4.29zM5.955 4c1.086 0 1.882.873 1.882 1.964 0 1.018-.869 1.89-1.955 1.89C4.87 7.855 4 6.983 4 5.892 4 4.873 4.869 4 5.955 4z"
  }));
};

var Instagram = function Instagram(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.03 2c.995.1 1.79.299 2.388.498.696.298 1.194.597 1.791 1.194s.895 1.094 1.194 1.79c.298.598.497 1.294.497 2.389.012.11.021.213.03.313l.016.196c.042.55.051 1.075.053 2.295v1.564c-.006 2.421-.099 2.737-.099 3.79a10.969 10.969 0 01-.497 2.389c-.299.696-.597 1.194-1.194 1.791s-1.095.895-1.791 1.194c-.597.298-1.294.497-2.388.497-.221.023-.413.04-.607.053l-.195.012c-.464.026-.997.033-2.002.034l-.987.001H7.97c-.995-.1-1.79-.299-2.388-.498-.696-.298-1.194-.597-1.791-1.194s-.895-1.094-1.194-1.79c-.298-.598-.497-1.294-.497-2.389-.012-.11-.021-.213-.03-.313l-.016-.196c-.037-.485-.049-.95-.052-1.892L2 12.864v-1.629l.002-.864c.005-1.254.024-1.664.098-2.4 0-1.095.199-1.792.398-2.389.298-.696.597-1.293 1.194-1.791.497-.597 1.094-.895 1.79-1.094.598-.299 1.294-.498 2.389-.498l.313-.03.196-.016.194-.013c.522-.032 1.096-.039 2.324-.04h2.105c1.765-.003 2.18-.015 3.027-.1zm-2.788 2h-2.484c-1.524.003-1.865.018-2.66.098-.976 0-1.464.196-1.854.393-.39.098-.78.392-1.073.687-.39.294-.586.589-.78 1.08-.098.392-.293.883-.293 1.865C4.02 8.894 4.004 9.24 4 10.64v1.409c0 2.552.098 2.847.098 3.926 0 .982.195 1.473.39 1.865.097.393.39.786.683 1.08.292.393.585.59 1.17.687.39.099.879.295 1.854.295.225.022.42.04.616.053l.198.012c.437.024.938.03 1.844.032l.961.001h.284c1.853 0 2.509-.052 3.146-.08l.202-.009c.17-.006.348-.01.554-.01.976 0 1.463-.195 1.854-.294.39-.098.78-.392 1.073-.687.293-.294.488-.589.683-1.08.097-.392.292-.883.292-1.865l.037-.387.014-.179.011-.178c.027-.448.034-.95.035-1.97v-1.497c-.004-1.466-.042-2.122-.07-2.676l-.01-.205c-.01-.236-.017-.47-.017-.76 0-.982-.195-1.473-.39-1.865-.097-.393-.39-.786-.683-1.08-.292-.393-.585-.589-1.073-.785-.39-.099-.878-.295-1.854-.295a25.565 25.565 0 00-.398-.037l-.184-.015c-.487-.035-.97-.043-2.078-.045zM12 7c2.745 0 5 2.255 5 5s-2.255 5-5 5-5-2.255-5-5 2.255-5 5-5zm0 2c-1.636 0-3 1.364-3 3s1.364 3 3 3 3-1.364 3-3-1.364-3-3-3zm5-3c.583 0 1 .417 1 1s-.417 1-1 1-1-.417-1-1 .417-1 1-1z"
  }));
};

var Pinterest = function Pinterest(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.925 4.05C16.524 2.728 14.585 2 12.465 2c-3.239 0-5.23 1.304-6.33 2.398C4.777 5.746 4 7.536 4 9.31c0 2.226.948 3.935 2.535 4.57a.853.853 0 00.319.065c.335 0 .6-.215.692-.56.054-.199.178-.688.232-.9.115-.419.022-.62-.23-.912-.459-.534-.673-1.165-.673-1.986 0-2.44 1.85-5.032 5.276-5.032 2.719 0 4.408 1.518 4.408 3.962 0 1.542-.338 2.97-.952 4.022-.427.73-1.178 1.601-2.33 1.601-.498 0-.945-.2-1.228-.551-.267-.332-.355-.76-.247-1.206.121-.504.286-1.03.446-1.538.292-.928.568-1.805.568-2.505 0-1.196-.75-2-1.863-2-1.416 0-2.526 1.413-2.526 3.217 0 .884.24 1.546.348 1.8l-1.44 5.99c-.116.486-.817 4.325.343 4.63 1.302.345 2.467-3.394 2.585-3.816.096-.344.433-1.643.638-2.441.63.595 1.642.997 2.627.997 1.858 0 3.528-.821 4.704-2.312C19.372 12.959 20 10.943 20 8.73c0-1.73-.756-3.437-2.075-4.68z"
  }));
};

var Settings = function Settings(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4C16,14.2,14.2,16,12,16z M12,10c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2\n\tc1.1,0,2-0.9,2-2C14,10.9,13.1,10,12,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,24c-1.7,0-3-1.3-3-3c0-0.3-0.2-0.6-0.4-0.7c-0.3-0.1-0.6-0.1-0.8,0.1c-1.2,1.2-3.2,1.2-4.3,0.1\n\tc-0.6-0.6-0.9-1.3-0.9-2.1s0.3-1.6,0.9-2.1c0.2-0.2,0.3-0.5,0.2-0.8c-0.1-0.2-0.3-0.4-0.6-0.4H3c-1.7,0-3-1.3-3-3s1.3-3,3-3\n\tc0.3,0,0.6-0.2,0.7-0.4c0.1-0.3,0.1-0.6-0.1-0.8C2.9,7.3,2.6,6.5,2.6,5.7c0-0.8,0.3-1.6,0.9-2.1c1.1-1.1,3.1-1.1,4.2,0\n\tC8,3.8,8.3,3.9,8.5,3.8c0.1,0,0.1,0,0.2-0.1C8.9,3.6,9,3.4,9,3.2V3c0-1.7,1.3-3,3-3s3,1.3,3,3c0,0.3,0.2,0.6,0.4,0.7\n\tc0.3,0.1,0.5,0.1,0.7-0.1c1.2-1.2,3.2-1.2,4.3-0.1c0.6,0.6,0.9,1.3,0.9,2.1S21,7.2,20.4,7.7c-0.2,0.2-0.3,0.5-0.2,0.8\n\tc0,0.1,0,0.1,0.1,0.2C20.4,8.9,20.6,9,20.8,9H21c1.7,0,3,1.3,3,3s-1.3,3-3,3c-0.3,0-0.6,0.2-0.7,0.4c0,0,0,0,0,0\n\tc-0.1,0.2-0.1,0.5,0.1,0.7c0.6,0.6,0.9,1.4,0.9,2.2c0,0.8-0.3,1.6-0.9,2.1c-1.1,1.1-3.1,1.1-4.2,0c-0.2-0.2-0.5-0.3-0.8-0.2\n\tc-0.2,0.1-0.4,0.3-0.4,0.6V21C15.1,22.7,13.7,24,12.1,24z M8.3,18.3c0.4,0,0.7,0.1,1.1,0.2c1,0.4,1.6,1.3,1.7,2.4c0,0,0,0.1,0,0.1\n\tc0,0.6,0.4,1,1,1s1-0.4,1-1v-0.2c0-1.1,0.6-2,1.6-2.4c1-0.4,2.1-0.2,2.9,0.5c0.5,0.5,1.1,0.4,1.5,0.1c0.2-0.2,0.3-0.4,0.3-0.7\n\tc0-0.3-0.1-0.5-0.3-0.7c-0.8-0.8-1-2-0.6-3c0.4-1,1.4-1.6,2.4-1.6c0.6,0,1.1-0.4,1.1-1s-0.4-1-1-1h-0.2c-1.1,0-2-0.6-2.4-1.6\n\tc0-0.1-0.1-0.2-0.1-0.3c-0.3-0.9-0.1-2,0.6-2.7c0.3-0.3,0.4-0.5,0.4-0.8S19.2,5.1,19,4.9c-0.4-0.4-1-0.4-1.4,0c-0.8,0.8-2,1-3,0.6\n\tc-1-0.4-1.6-1.4-1.6-2.4C13,2.4,12.6,2,12,2s-1,0.4-1,1v0.2c0,1.1-0.6,2-1.6,2.4c-0.1,0-0.2,0.1-0.3,0.1C8.2,6,7.1,5.8,6.4,5.1\n\tC5.9,4.6,5.3,4.6,4.9,5C4.7,5.2,4.6,5.4,4.6,5.7c0,0.3,0.1,0.5,0.3,0.7c0.8,0.8,1,2,0.6,3c-0.4,1-1.3,1.6-2.4,1.7c0,0-0.1,0-0.1,0\n\tc-0.6,0-1,0.4-1,1s0.4,1,1,1h0.2c1.1,0,2,0.6,2.4,1.6c0.4,1,0.2,2.1-0.5,2.9c-0.3,0.3-0.4,0.5-0.4,0.8s0.1,0.5,0.3,0.7\n\tc0.4,0.4,1,0.4,1.4,0C7,18.5,7.7,18.3,8.3,18.3z M19.4,15L19.4,15L19.4,15z"
  }));
};

var HelpCircle = function HelpCircle(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9\n\tC21,7,17,3,12,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,14c-0.4,0-0.8-0.3-0.9-0.7c-0.2-0.5,0.1-1.1,0.6-1.3c0.6-0.2,2.3-1,2.3-2.1c0-1-0.7-1.8-1.7-2c-1-0.2-1.9,0.4-2.2,1.3\n\tc-0.2,0.5-0.8,0.8-1.3,0.6C8.2,9.8,8,9.2,8.1,8.7c0.6-1.8,2.5-2.9,4.4-2.6c1.9,0.3,3.3,2,3.3,3.9c0,2.6-3.3,3.8-3.7,3.9\n\tC12.1,14,12,14,11.9,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S12.6,18,12,18z"
  }));
};

var icon24Subset = {
  icons: {
    alertCircle24: /*#__PURE__*/React.createElement(AlertCircle, null),
    arrowLeft24: /*#__PURE__*/React.createElement(ArrowLeft, null),
    assortment24: /*#__PURE__*/React.createElement(Assortment, null),
    bell24: /*#__PURE__*/React.createElement(Bell, null),
    chevronDown24: /*#__PURE__*/React.createElement(ChevronDown$1, null),
    chevronUp24: /*#__PURE__*/React.createElement(ChevronUp$1, null),
    clear24: /*#__PURE__*/React.createElement(Clear, null),
    close24: /*#__PURE__*/React.createElement(Close, null),
    eye24: /*#__PURE__*/React.createElement(Eye, null),
    facebook24: /*#__PURE__*/React.createElement(Facebook, null),
    folderShared24: /*#__PURE__*/React.createElement(FolderShared, null),
    folder24: /*#__PURE__*/React.createElement(Folder, null),
    globe24: /*#__PURE__*/React.createElement(Globe, null),
    hamburger24: /*#__PURE__*/React.createElement(Hamburger, null),
    helpCircle24: /*#__PURE__*/React.createElement(HelpCircle, null),
    horizKabob24: /*#__PURE__*/React.createElement(HorizKabob, null),
    infoHover24: /*#__PURE__*/React.createElement(InfoHover, null),
    instagram24: /*#__PURE__*/React.createElement(Instagram, null),
    linkedin24: /*#__PURE__*/React.createElement(Linkedin, null),
    merchant24: /*#__PURE__*/React.createElement(Merchant$1, null),
    myDrive24: /*#__PURE__*/React.createElement(MyDrive$1, null),
    pencil24: /*#__PURE__*/React.createElement(Pencil, null),
    pinterest24: /*#__PURE__*/React.createElement(Pinterest, null),
    plus24: /*#__PURE__*/React.createElement(Plus$1, null),
    timer24: /*#__PURE__*/React.createElement(Timer, null),
    trash24: /*#__PURE__*/React.createElement(Trash$1, null),
    userPlus24: /*#__PURE__*/React.createElement(UserPlus, null),
    user24: /*#__PURE__*/React.createElement(User$1, null),
    users24: /*#__PURE__*/React.createElement(Users$1, null),
    whiteboard24: /*#__PURE__*/React.createElement(Whiteboard, null),
    rollup24: /*#__PURE__*/React.createElement(Rollup$1, null),
    settings24: /*#__PURE__*/React.createElement(Settings, null),
    shortcutAssortment24: /*#__PURE__*/React.createElement(ShortcutAssortment, null),
    shortcutFolder24: /*#__PURE__*/React.createElement(ShortcutFolder, null),
    shortcutRollup24: /*#__PURE__*/React.createElement(ShortcutRollup, null),
    shortcutWhiteboard24: /*#__PURE__*/React.createElement(ShortcutWhiteboard, null),
    star24: /*#__PURE__*/React.createElement(Star$2, null),
    success24: /*#__PURE__*/React.createElement(Success, null)
  }
};

var Folder$1 = function Folder(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    clipRule: "evenodd",
    fillRule: "evenodd",
    width: "64",
    height: "64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2,22.5h-0.7c0-3.6-3-6.5-6.6-6.5H28.7l-4.7-6.8c-0.3-0.4-0.7-0.7-1.2-0.7H10.1c-3.6,0-6.6,2.9-6.6,6.5v35\n\tc0,3.6,3,6.5,6.6,6.5h40.8c3.7,0,5.9-3.1,6.6-6.2l0,0L62.6,28c0.1-0.3,0.1-0.7,0.1-1C62.7,24.5,60.7,22.5,58.2,22.5z M10.1,11.5h12\n\tl4.7,6.8C27,18.8,27.5,19,28,19h23c2,0,3.6,1.6,3.6,3.5H13.4c-2.1,0-3.9,1.4-4.4,3.5L6.5,37.1V15C6.5,13.1,8.1,11.5,10.1,11.5z\n\t M59.7,27.3l-5.2,22.3l0,0c0,0,0,0,0,0c-0.4,1.9-1.6,3.8-3.6,3.8H10.1c-1.8,0-3.3-1.3-3.6-3l5.4-23.8c0.2-0.7,0.8-1.2,1.5-1.2h44.8\n\tc0.8,0,1.5,0.7,1.5,1.5C59.7,27.1,59.7,27.2,59.7,27.3z"
  }));
};

var Star$3 = function Star(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-800.000000, -309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(622.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "64",
    height: "64"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#BDBDBD",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "32 3.55555556 40.7893333 21.3617778 60.4444444 24.2346667 46.2222222 38.0871111 49.5786667 57.6568889 32 48.4124444 14.4213333 57.6568889 17.7777778 38.0871111 3.55555556 24.2346667 23.2106667 21.3617778"
  }))))));
};

var Settings$1 = function Settings(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "icon-settings",
    clipPath: "url(#clip0_3018_132380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page level actions copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: "32.165",
    cy: "32.1638",
    r: "7.68137",
    stroke: "#BDBDBD",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1124 39.8464C50.4151 41.4264 50.7497 43.2718 51.9574 44.5064L52.111 44.6601C53.0726 45.6206 53.6129 46.924 53.6129 48.2831C53.6129 49.6423 53.0726 50.9456 52.111 51.9062C51.1505 52.8678 49.8471 53.4081 48.488 53.4081C47.1288 53.4081 45.8254 52.8678 44.8649 51.9062L44.7113 51.7525C43.4767 50.5449 41.6313 50.2103 40.0513 50.9076C38.5035 51.5709 37.4975 53.09 37.4908 54.7739V55.2092C37.4908 58.0374 35.1981 60.3301 32.3699 60.3301C29.5417 60.3301 27.249 58.0374 27.249 55.2092V54.9787C27.2084 53.2444 26.1118 51.7112 24.4837 51.1124C22.9036 50.4151 21.0583 50.7497 19.8236 51.9574L19.67 52.111C18.7095 53.0726 17.4061 53.6129 16.047 53.6129C14.6878 53.6129 13.3844 53.0726 12.4239 52.111C11.4623 51.1505 10.922 49.8471 10.922 48.488C10.922 47.1288 11.4623 45.8254 12.4239 44.8649L12.5775 44.7113C13.7852 43.4767 14.1198 41.6313 13.4225 40.0513C12.7592 38.5035 11.2401 37.4975 9.55619 37.4908H9.12092C6.29271 37.4908 4 35.1981 4 32.3699C4 29.5417 6.29271 27.249 9.12092 27.249H9.35136C11.0856 27.2084 12.6188 26.1118 13.2176 24.4837C13.915 22.9036 13.5804 21.0583 12.3727 19.8236L12.2191 19.67C11.2575 18.7095 10.7172 17.4061 10.7172 16.047C10.7172 14.6878 11.2575 13.3844 12.2191 12.4239C13.1796 11.4623 14.483 10.922 15.8421 10.922C17.2013 10.922 18.5046 11.4623 19.4652 12.4239L19.6188 12.5775C20.8534 13.7852 22.6988 14.1198 24.2788 13.4225H24.4837C26.0314 12.7592 27.0374 11.2401 27.0441 9.55619V9.12092C27.0441 6.29271 29.3368 4 32.165 4C34.9932 4 37.286 6.29271 37.286 9.12092V9.35136C37.2927 11.0352 38.2987 12.5543 39.8464 13.2176C41.4264 13.915 43.2718 13.5804 44.5064 12.3727L44.6601 12.2191C45.6206 11.2575 46.924 10.7172 48.2831 10.7172C49.6423 10.7172 50.9456 11.2575 51.9062 12.2191C52.8678 13.1796 53.4081 14.483 53.4081 15.8421C53.4081 17.2013 52.8678 18.5046 51.9062 19.4652L51.7525 19.6188C50.5449 20.8534 50.2103 22.6988 50.9076 24.2788V24.4837C51.5709 26.0314 53.09 27.0374 54.7739 27.0441H55.2092C58.0374 27.0441 60.3301 29.3368 60.3301 32.165C60.3301 34.9932 58.0374 37.286 55.2092 37.286H54.9787C53.2949 37.2927 51.7758 38.2987 51.1124 39.8464Z",
    stroke: "#BDBDBD",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3018_132380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "64",
    height: "64",
    fill: "white"
  }))));
};

var icon64Subset = {
  icons: {
    folder64: /*#__PURE__*/React.createElement(Folder$1, null),
    star64: /*#__PURE__*/React.createElement(Star$3, null),
    settings64: /*#__PURE__*/React.createElement(Settings$1, null)
  }
};

var Cancel = function Cancel(_props) {
  return /*#__PURE__*/React.createElement(SvgIcon, {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,19c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l12-12c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-12,12C6.5,18.9,6.3,19,6,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19c-0.3,0-0.5-0.1-0.7-0.3l-12-12c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l12,12c0.4,0.4,0.4,1,0,1.4C18.5,18.9,18.3,19,18,19\n\tz"
  }));
};

var iconOverrideSubset = {
  icons: {
    Cancel: /*#__PURE__*/React.createElement(Cancel, null)
  }
};
var unregisterExistingIcons = function unregisterExistingIcons() {
  return unregisterIcons(Object.keys(iconOverrideSubset.icons));
};

var FolderSync = function FolderSync(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-688.000000, -152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(688.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "24",
    x: "0",
    y: "0",
    width: "64",
    height: "64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6666667,50.6666667 C58.6666667,53.6121853 56.278852,56 53.3333333,56 L10.6666667,56 C7.721148,56 5.33333333,53.6121853 5.33333333,50.6666667 L5.33333333,13.3333333 C5.33333333,10.3878147 7.721148,8 10.6666667,8 L24,8 L29.3333333,16 L53.3333333,16 C56.278852,16 58.6666667,18.3878147 58.6666667,21.3333333 L58.6666667,50.6666667 Z",
    id: "Path",
    stroke: "#8E8E8E",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "24",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw",
    transform: "translate(1.000000, 3.000000)",
    stroke: "#8E8E8E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "22 1 22 7 16 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 17 0 11 6 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51,6 C3.54088164,3.08681165 5.99426717,0.906218245 9.00828672,0.224258265 C12.0223063,-0.457701715 15.1754408,0.454345733 17.36,2.64 L22,7 M0,11 L4.64,15.36 C6.82455916,17.5456543 9.97769373,18.4577017 12.9917133,17.7757417 C16.0057328,17.0937818 18.4591184,14.9131883 19.49,12",
    id: "Shape"
  })))))));
};

var initializeIcons = function initializeIcons() {
  // TODO: remove the following line once all the Fluent ui icons were replaced and the new svg icons are used
  initializeIcons$1(undefined, {
    disableWarnings: true
  });
  unregisterExistingIcons();
  registerIcons({
    icons: _extends({}, icon12Subset.icons, icon14Subset.icons, icon18Subset.icons, icon24Subset.icons, icon64Subset.icons, iconOverrideSubset.icons)
  }, {
    disableWarnings: true
  });
};

var SEARCH_SECTION = 'searchSection';
var EMPTY_SECTION = 'emptySection';
var Dropdown = function Dropdown(_ref) {
  var testId = _ref.testId,
      _ref$multiSelect = _ref.multiSelect,
      multiSelect = _ref$multiSelect === void 0 ? false : _ref$multiSelect,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      selectedKey = _ref.selectedKey,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? false : _ref$isSearchable,
      onChange = _ref.onChange,
      selectAllText = _ref.selectAllText,
      searchBoxPlaceholder = _ref.searchBoxPlaceholder,
      noResultsText = _ref.noResultsText,
      onRenderCustomOption = _ref.onRenderCustomOption,
      props = _objectWithoutPropertiesLoose(_ref, ["testId", "multiSelect", "options", "selectedKey", "isSearchable", "onChange", "selectAllText", "searchBoxPlaceholder", "noResultsText", "onRenderCustomOption"]);

  var styles = React.useMemo(function () {
    return {
      dropdownItemHeader: [{
        height: 0
      }, multiSelect && {
        height: 38
      }, isSearchable && {
        height: 40
      }, multiSelect && isSearchable && {
        height: 70
      }],
      dropdownItems: {
        // Get second div(list of options) to set a max height
        '& > div:nth-child(2)': {
          overflowY: 'auto',
          maxHeight: 250,
          // Get first div(header) from the list of options to hide it, since it takes a white space
          '> div:first-child': {
            display: 'none'
          }
        }
      },
      callout: {
        '.ms-Checkbox-label': {
          textAlign: 'left'
        },
        '.ms-Checkbox-text': {
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        },
        selectors: {
          '.ms-Callout-main': [!multiSelect && !isSearchable && {
            maxHeight: '300px !important'
          }]
        }
      },
      title: {
        paddingRight: 6
      }
    };
  }, [multiSelect, isSearchable]);
  var classes = React.useMemo(function () {
    return mergeStyleSets({
      checkbox: [{
        textAlign: 'center',
        width: '100%',
        selectors: {
          '&.is-checked': {
            backgroundColor: nuOrderTheme.palette.selectedDropdownItemBackground
          },
          label: {
            width: '100%',
            padding: 8
          }
        }
      }],
      selectAllContainer: {
        height: 38,
        display: 'flex',
        alignItems: 'center'
      },
      selectAll: {
        width: '100%',
        selectors: {
          label: {
            width: '100%'
          }
        }
      },
      empty: {
        textAlign: 'center',
        padding: '8px 0',
        display: 'block'
      }
    });
  }, []);
  var normalizedSelectedKey = React.useMemo(function () {
    return selectedKey ? Array.isArray(selectedKey) ? selectedKey : [selectedKey] : [];
  }, [selectedKey]);

  var _React$useState = React.useState(),
      searchTerm = _React$useState[0],
      setSearchTerm = _React$useState[1];

  var _React$useState2 = React.useState(normalizedSelectedKey),
      selectedIndices = _React$useState2[0],
      setSelectedIndices = _React$useState2[1];

  React.useEffect(function () {
    setSelectedIndices(normalizedSelectedKey);
  }, [normalizedSelectedKey]);
  var handleRenderCaretDown = React.useCallback(function () {
    return /*#__PURE__*/React.createElement(Icon, {
      iconName: "chevronDown14"
    });
  }, []);
  var setupData = React.useMemo(function () {
    return isSearchable || multiSelect ? [{
      key: SEARCH_SECTION,
      text: '-',
      itemType: DropdownMenuItemType.Header
    }, {
      key: 'divider',
      text: '-',
      itemType: DropdownMenuItemType.Divider
    }, {
      key: 'optionsSection',
      text: '-',
      itemType: DropdownMenuItemType.Header
    }] : [];
  }, [isSearchable, multiSelect]);
  var handleRenderTitle = React.useCallback(function () {
    if (multiSelect && options.length === (selectedIndices == null ? void 0 : selectedIndices.length)) {
      return /*#__PURE__*/React.createElement("span", {
        "data-test": DATATEST.BASIC_INPUT.MULTI_SELECT.TITLE
      }, selectAllText);
    }

    return /*#__PURE__*/React.createElement("span", {
      "data-test": DATATEST.BASIC_INPUT.MULTI_SELECT.TITLE
    }, options.filter(function (option) {
      return selectedIndices == null ? void 0 : selectedIndices.some(function (key) {
        return key === option.key;
      });
    }).map(function (it) {
      return it.text;
    }).join(', '));
  }, [selectedIndices, options, multiSelect, selectAllText]);

  var _React$useMemo = React.useMemo(function () {
    var filteredData = searchTerm ? options.filter(function (tag) {
      return tag.text.toLowerCase().includes(searchTerm.toLowerCase());
    }) : options;
    filteredData = filteredData.length ? filteredData : [{
      key: EMPTY_SECTION,
      text: '-',
      itemType: DropdownMenuItemType.Normal
    }];
    return [filteredData, setupData.concat(filteredData)];
  }, [searchTerm, options, setupData]),
      filteredOptions = _React$useMemo[0],
      groupedOptions = _React$useMemo[1];

  var handleChangeValue = React.useCallback(function (item) {
    return function (event, checked) {
      var updatedItems = multiSelect ? selectedIndices != null && selectedIndices.length ? [].concat(selectedIndices) : [] : [];

      if (item.key === SEARCH_SECTION) {
        //@ts-expect-error TECH-DEBT we should update the type of the event in line 216
        var isIndeterminated = (event == null ? void 0 : event.target.ariaChecked) === 'mixed';
        filteredOptions.forEach(function (option) {
          var index = updatedItems.indexOf(option.key); // If the selectAll checkbox was checked or is on a indeterminate state, we should select all the itens in the options

          if (checked || isIndeterminated) {
            index === -1 && updatedItems.push(option.key);
          } else if (index !== -1) {
            if (!option.disabled) {
              // ensure that we only update non-disabled items
              updatedItems.splice(index, 1);
            }
          } else if (index === -1) {
            updatedItems.push(option.key);
          }
        });
      } else {
        var index = updatedItems.indexOf(item.key);

        if (checked) {
          updatedItems.push(item.key);
        } else {
          updatedItems.splice(index, 1);
        }
      }

      setSelectedIndices(updatedItems);

      if (multiSelect) {
        var selectedOptions = filteredOptions.filter(function (filteredOption) {
          return updatedItems.includes(filteredOption.key);
        });
        onChange && onChange(updatedItems, selectedOptions);
      } else {
        onChange && onChange(updatedItems == null ? void 0 : updatedItems[0], item);
      }
    };
  }, [filteredOptions, selectedIndices, multiSelect, onChange]);
  var handleRenderOption = React.useCallback(function (option, defaultRender) {
    if ((option == null ? void 0 : option.itemType) === SelectableOptionMenuItemType.Header) {
      if (option.key === SEARCH_SECTION) {
        var validOptions = filteredOptions.filter(function (it) {
          return it.key !== EMPTY_SECTION;
        });
        var selectedItemsSize = validOptions.filter(function (it) {
          return selectedIndices == null ? void 0 : selectedIndices.includes(it.key);
        }).length;
        var isSelectAllIndeterminated = selectedItemsSize > 0 && selectedItemsSize !== validOptions.length;
        var isSelectAllSelected = !!(validOptions.length && selectedItemsSize === validOptions.length);
        return /*#__PURE__*/React.createElement("div", {
          key: option.key,
          "data-test": DATATEST.BASIC_INPUT.MULTI_SELECT.SEARCH_AREA
        }, isSearchable && /*#__PURE__*/React.createElement(SearchBox, {
          placeholder: searchBoxPlaceholder,
          onSearch: function onSearch(newValue) {
            setSearchTerm(newValue);
          },
          onChange: function onChange(_e, newValue) {
            setSearchTerm(newValue);
          }
        }), multiSelect && /*#__PURE__*/React.createElement("div", {
          className: classes.selectAllContainer
        }, /*#__PURE__*/React.createElement(Checkbox, {
          onChange: handleChangeValue(option),
          label: selectAllText,
          indeterminate: isSelectAllIndeterminated,
          checked: isSelectAllSelected,
          disabled: validOptions.length === 0,
          className: classes.selectAll,
          styles: {
            label: {
              marginBottom: 0
            },
            checkmark: {
              height: 'auto',
              top: '1px'
            }
          }
        })));
      }

      return null;
    } else if (onRenderCustomOption) {
      return onRenderCustomOption(option, defaultRender);
    }

    return defaultRender && defaultRender(option);
  }, [setSearchTerm, classes, handleChangeValue, filteredOptions, selectedIndices, multiSelect, isSearchable, searchBoxPlaceholder, selectAllText]);
  var handleRenderItem = React.useCallback(function (option, defaultRender) {
    if (multiSelect && !setupData.some(function (it) {
      return it.key === option.key;
    }) && option.key !== EMPTY_SECTION) {
      return /*#__PURE__*/React.createElement(Checkbox, {
        onChange: handleChangeValue(option),
        label: option.text,
        key: option.key,
        disabled: option.disabled,
        checked: (selectedIndices == null ? void 0 : selectedIndices.some(function (it) {
          return it === option.key;
        })) || false,
        className: classes.checkbox,
        styles: {
          label: {
            marginBottom: 0
          }
        }
      });
    } else if (option.key === EMPTY_SECTION) {
      return /*#__PURE__*/React.createElement(Text, {
        key: option.key,
        variant: "medium",
        nowrap: true,
        as: "div",
        className: classes.empty
      }, noResultsText);
    }

    return defaultRender(option);
  }, [multiSelect, selectedIndices, classes, setupData, handleChangeValue, noResultsText]);
  var handleDismiss = React.useCallback(function () {
    setSearchTerm('');
  }, [setSearchTerm]);
  var handleChange = React.useCallback(function (event, option) {
    handleChangeValue(option)(event, true);
  }, [handleChangeValue]); // pass selected keys from local state into internal Dropdown so that it calls hooks
  // like onRenderTitle, onRenderPlaceholder and potentially others, in the right time

  var internalSelectedKey = !multiSelect && selectedIndices.length ? selectedIndices[0] : undefined;
  var internalSelectedKeys = multiSelect ? selectedIndices : undefined;
  return /*#__PURE__*/React.createElement(Dropdown$1, Object.assign({
    "data-test": testId,
    onRenderTitle: handleRenderTitle,
    onRenderOption: handleRenderOption,
    onRenderCaretDown: handleRenderCaretDown,
    onRenderItem: handleRenderItem,
    onDismiss: handleDismiss,
    onChange: handleChange,
    styles: styles,
    options: groupedOptions,
    multiSelect: multiSelect,
    selectedKey: internalSelectedKey,
    selectedKeys: internalSelectedKeys
  }, props));
};

var classNames = /*#__PURE__*/mergeStyleSets({
  textFieldLoading: {
    selectors: {
      'input[disabled]': {
        color: nuOrderTheme.palette.disabledInputColor,
        backgroundColor: nuOrderTheme.palette.disabledInputBackground + " !important",
        borderColor: nuOrderTheme.palette.disabledInputBackground,
        padding: '0px 8px'
      }
    }
  }
});
var TagPicker = function TagPicker(_ref) {
  var isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      props = _objectWithoutPropertiesLoose(_ref, ["isLoading", "loadingText"]);

  if (isLoading) {
    return /*#__PURE__*/React.createElement(TextField, {
      "data-test": DATATEST.BASIC_INPUT.TAG_PICKER.LOADING,
      disabled: true,
      value: loadingText,
      className: classNames.textFieldLoading
    });
  }

  return /*#__PURE__*/React.createElement(TagPicker$1, Object.assign({}, props));
};

var Toggle = function Toggle(_ref) {
  var testId = _ref.testId,
      props = _objectWithoutPropertiesLoose(_ref, ["testId"]);

  return /*#__PURE__*/React.createElement(Toggle$1, Object.assign({
    "data-test": testId
  }, props));
};

var DIALOG_PADDING = 40;
var PromptDialog = function PromptDialog(_ref) {
  var title = _ref.title,
      description = _ref.description,
      confirmLabel = _ref.confirmLabel,
      open = _ref.open,
      onPromptTextChange = _ref.onPromptTextChange,
      onConfirm = _ref.onConfirm,
      onClose = _ref.onClose,
      _ref$confirmButtonDis = _ref.confirmButtonDisabled,
      confirmButtonDisabled = _ref$confirmButtonDis === void 0 ? false : _ref$confirmButtonDis,
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue,
      errorMessage = _ref.errorMessage,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      customTextForSave = _ref.customTextForSave,
      customTextForCancel = _ref.customTextForCancel,
      closeButtonAriaLabel = _ref.closeButtonAriaLabel,
      blankErrorMessage = _ref.blankErrorMessage;

  var _React$useState = React.useState(initialValue),
      promptText = _React$useState[0],
      setPromptText = _React$useState[1];

  var _React$useState2 = React.useState(errorMessage),
      errorMessageDisplay = _React$useState2[0],
      setErrorMessageDisplay = _React$useState2[1];

  var inputEl = React.useRef(null);
  React.useEffect(function () {
    if (open && initialValue) {
      setPromptText(initialValue);
    }
  }, [open, initialValue]);
  React.useEffect(function () {
    setErrorMessageDisplay(errorMessage);
  }, [errorMessage, setErrorMessageDisplay]);
  var handlePromptTextChange = React.useCallback(function (_e, newValue) {
    setPromptText(newValue);
    var saveErrorMessage = !newValue ? blankErrorMessage : '';
    setErrorMessageDisplay(saveErrorMessage);
    onPromptTextChange && onPromptTextChange(newValue);
  }, [blankErrorMessage, onPromptTextChange]);
  var handleConfirm = React.useCallback(function () {
    var _promptText$trim;

    // NOTE: Keep text when checking validation.
    var trimedText = (_promptText$trim = promptText == null ? void 0 : promptText.trim()) != null ? _promptText$trim : '';
    onConfirm(trimedText);
  }, [onConfirm, promptText]);
  var handleSubmit = React.useCallback(function (event) {
    event.preventDefault();
    handleConfirm();
  }, [handleConfirm]);
  var handleKeyDown = React.useCallback(function (event) {
    if (event.keyCode === Keys.KEY_DOT) {
      event.preventDefault();
    }
  }, []);
  var handleOnPaste = React.useCallback(function (e) {
    var clipboardData = e.clipboardData;
    var pastedText = clipboardData.getData('Text');

    if (pastedText.indexOf('.') !== -1) {
      e.preventDefault();
    }
  }, []);
  var isConfirmDisabled = React.useMemo(function () {
    if (!promptText) {
      return true;
    }

    return confirmButtonDisabled;
  }, [confirmButtonDisabled, promptText]);
  var dialogContentProps = React.useMemo(function () {
    return {
      type: DialogType.normal,
      title: title,
      closeButtonAriaLabel: closeButtonAriaLabel,
      showCloseButton: true,
      subText: description
    };
  }, [closeButtonAriaLabel, title, description]);
  var modalProps = React.useMemo(function () {
    return {
      titleAriaId: 'dialogLabel',
      subtitleAriaId: 'subTextLabel',
      isBlocking: false,
      onDismissed: function onDismissed() {
        setPromptText('');
        inputEl.current = null;
        setErrorMessageDisplay('');
      }
    };
  }, []);
  var classes = React.useMemo(function () {
    return mergeStyleSets({
      errorMessageStyle: {
        maxWidth: "calc(100vw - " + DIALOG_PADDING + ")",
        width: 340 - DIALOG_PADDING + "px !important"
      }
    });
  }, []);
  var errorMessageComponent = errorMessageDisplay ? /*#__PURE__*/React.createElement(Text, {
    "data-test": DATATEST.SURFACES.DIALOG.ERROR,
    className: classes.errorMessageStyle,
    as: "span",
    title: errorMessageDisplay
  }, errorMessageDisplay) : '';
  return /*#__PURE__*/React.createElement(Dialog, {
    hidden: !open,
    onDismiss: onClose,
    dialogContentProps: dialogContentProps,
    modalProps: modalProps
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(TextField, {
    "data-test": DATATEST.SURFACES.DIALOG.INPUT,
    componentRef: function componentRef(el) {
      if (el && inputEl.current === null) {
        inputEl.current = el;
        el.select();
      }
    },
    value: promptText,
    onChange: handlePromptTextChange,
    label: confirmLabel,
    errorMessage: errorMessageComponent,
    disabled: isLoading,
    onKeyDown: handleKeyDown,
    onPaste: handleOnPaste
  })), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(DefaultButton, {
    "data-test": DATATEST.SURFACES.DIALOG.CANCEL_BTN,
    onClick: onClose,
    text: customTextForCancel,
    disabled: isLoading
  }), /*#__PURE__*/React.createElement(PrimaryButton, {
    "data-test": DATATEST.SURFACES.DIALOG.SAVE_BTN,
    onClick: handleConfirm,
    text: customTextForSave,
    disabled: isConfirmDisabled || !!errorMessageDisplay
  }, isLoading && /*#__PURE__*/React.createElement(Spinner, {
    size: SpinnerSize.small
  })))));
};

var ConfirmDialog = function ConfirmDialog(_ref) {
  var open = _ref.open,
      onConfirm = _ref.onConfirm,
      onClose = _ref.onClose,
      onFinished = _ref.onFinished,
      _ref$confirmButtonDis = _ref.confirmButtonDisabled,
      confirmButtonDisabled = _ref$confirmButtonDis === void 0 ? false : _ref$confirmButtonDis,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      contentProps = _ref.contentProps,
      children = _ref.children,
      isBlocking = _ref.isBlocking,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 600 : _ref$width,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      containerId = _ref.containerId,
      closeButtonAriaLabel = _ref.closeButtonAriaLabel,
      customLeftLabel = _ref.customLeftLabel,
      onLeftActionClicked = _ref.onLeftActionClicked,
      _ref$hideCancelButton = _ref.hideCancelButton,
      hideCancelButton = _ref$hideCancelButton === void 0 ? false : _ref$hideCancelButton,
      leftButtonDisabled = _ref.leftButtonDisabled,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? true : _ref$scrollable;
  var classes = React.useMemo(function () {
    return mergeStyleSets({
      customLeftButtonStyle: {
        display: 'none',
        '@media (min-width: 541px)': {
          display: 'block',
          position: 'absolute',
          left: 0,
          margin: 'auto auto auto 0'
        }
      },
      dialog: _extends({}, !scrollable ? {
        selectors: {
          '.ms-Dialog-header': {
            position: 'absolute',
            top: '0'
          },
          '.ms-Dialog-content': {
            overflow: 'hidden !important'
          }
        }
      } : {
        selectors: {
          '.ms-Dialog-content': {
            overflow: 'hidden !important'
          }
        }
      }),
      footer: _extends({}, !scrollable ? {
        position: 'absolute',
        width: 'auto',
        margin: '0 24px',
        paddingTop: '16px',
        paddingBottom: '24px',
        fontSize: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: nuOrderTheme.palette.white,
        lineHeight: 0,
        height: '40px',
        boxSizing: 'content-box'
      } : {})
    });
  }, [scrollable]);
  var dialogContentProps = React.useMemo(function () {
    return _extends({
      type: DialogType.normal,
      closeButtonAriaLabel: closeButtonAriaLabel,
      showCloseButton: true,
      titleProps: {
        'data-test': DATATEST.SURFACES.DIALOG.TITLE
      },
      subTextId: containerId ? containerId + "_subtext" : undefined
    }, contentProps);
  }, [contentProps, containerId, closeButtonAriaLabel]);
  var modalProps = React.useMemo(function () {
    return {
      titleAriaId: 'dialogLabel',
      subtitleAriaId: 'subTextLabel',
      isBlocking: isBlocking != null ? isBlocking : false,
      styles: {
        main: {
          width: width + "px !important",
          maxWidth: '100vw !important'
        },
        scrollableContent: {
          marginBottom: scrollable ? 0 : '80px',
          marginTop: scrollable ? 0 : '56px'
        }
      },
      className: classes.dialog,
      containerClassName: containerId,
      onDismissed: function onDismissed() {
        onFinished && onFinished();
      }
    };
  }, [onFinished, width, containerId, isBlocking, classes, scrollable]);
  return /*#__PURE__*/React.createElement(Dialog, {
    hidden: !open,
    onDismiss: onClose,
    dialogContentProps: dialogContentProps,
    modalProps: modalProps
  }, children, /*#__PURE__*/React.createElement(DialogFooter, {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(ButtonGroup, null, customLeftLabel && /*#__PURE__*/React.createElement(DefaultButton, {
    className: classes.customLeftButtonStyle,
    "data-test": DATATEST.SURFACES.DIALOG.CUSTOM_LEFT_BTN,
    onClick: onLeftActionClicked,
    text: customLeftLabel,
    disabled: leftButtonDisabled
  }), !hideCancelButton && /*#__PURE__*/React.createElement(DefaultButton, {
    "data-test": DATATEST.SURFACES.DIALOG.CANCEL_BTN,
    onClick: onClose,
    text: cancelLabel,
    disabled: isLoading
  }), /*#__PURE__*/React.createElement(PrimaryButton, {
    "data-test": DATATEST.SURFACES.DIALOG.SAVE_BTN,
    onClick: onConfirm,
    text: okLabel,
    disabled: confirmButtonDisabled
  }, isLoading && /*#__PURE__*/React.createElement(Spinner, {
    size: SpinnerSize.small
  })))));
};

var AlertDialog = function AlertDialog(_ref) {
  var onOk = _ref.onOk,
      open = _ref.open,
      title = _ref.title,
      message = _ref.message,
      children = _ref.children,
      isBlocking = _ref.isBlocking,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 400 : _ref$width,
      okLabel = _ref.okLabel,
      containerId = _ref.containerId,
      closeButtonAriaLabel = _ref.closeButtonAriaLabel;
  var titleElement = React.useMemo(function () {
    return /*#__PURE__*/React.createElement(DialogTitle, {
      iconName: "alertCircle24",
      mainTitle: title,
      iconColor: nuOrderTheme.palette.red
    });
  }, [title]);
  var dialogContentProps = React.useMemo(function () {
    return {
      type: DialogType.normal,
      closeButtonAriaLabel: closeButtonAriaLabel,
      titleProps: {
        'data-test': DATATEST.SURFACES.DIALOG.TITLE
      },
      subTextId: containerId ? containerId + "_subtext" : undefined,
      title: titleElement,
      subText: message,
      showCloseButton: true
    };
  }, [titleElement, message, containerId, closeButtonAriaLabel]);
  var modalProps = React.useMemo(function () {
    return {
      titleAriaId: 'dialogLabel',
      subtitleAriaId: 'subTextLabel',
      isBlocking: isBlocking != null ? isBlocking : false,
      styles: {
        main: {
          width: width + "px !important",
          maxWidth: '100vw !important'
        }
      },
      containerClassName: containerId
    };
  }, [width, containerId, isBlocking]);
  return /*#__PURE__*/React.createElement(Dialog, {
    hidden: !open,
    onDismiss: onOk,
    dialogContentProps: dialogContentProps,
    modalProps: modalProps
  }, children, /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    "data-test": DATATEST.SURFACES.DIALOG.OK_BTN,
    onClick: onOk,
    primary: true,
    text: okLabel
  }))));
};

var DialogTitle = function DialogTitle(_ref) {
  var iconName = _ref.iconName,
      iconColor = _ref.iconColor,
      mainTitle = _ref.mainTitle,
      subTitle = _ref.subTitle,
      onBack = _ref.onBack;
  var classes = React.useMemo(function () {
    return mergeStyleSets({
      titleContainer: {
        hight: '24px',
        display: 'flex'
      },
      titleTextBox: {
        fontSize: '16px',
        lineHeight: '24px',
        marginLeft: iconName ? '16px' : 0,
        color: nuOrderTheme.palette.black,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        marginRight: '25px'
      },
      titleName: {
        fontSize: '14px',
        color: nuOrderTheme.palette.greyDarker
      },
      titleIcon: {
        ' svg': [{
          fill: iconColor || nuOrderTheme.palette.greyDarker
        }, onBack && {
          fill: nuOrderTheme.palette.black
        }],
        '&:hover': [onBack && {
          cursor: 'pointer'
        }]
      }
    });
  }, [onBack, iconName, iconColor]);
  var handleGoBack = React.useCallback(function () {
    onBack == null ? void 0 : onBack();
  }, [onBack]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.titleContainer
  }, !!iconName && /*#__PURE__*/React.createElement(Icon, {
    iconName: iconName || '',
    className: classes.titleIcon,
    onClick: handleGoBack
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.titleTextBox
  }, mainTitle, ' ', subTitle && /*#__PURE__*/React.createElement("span", {
    className: classes.titleName
  }, " - ", subTitle)));
};

var Loading = function Loading(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var classes = React.useMemo(function () {
    return mergeStyleSets({
      wrapper: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes.wrapper, className)
  }, /*#__PURE__*/React.createElement(Spinner, Object.assign({}, props, {
    size: props.size || SpinnerSize.large
  })));
};

var ToastNotification = function ToastNotification(_ref) {
  var styles = _ref.styles,
      children = _ref.children,
      testId = _ref.testId,
      messageBarType = _ref.messageBarType,
      onDismiss = _ref.onDismiss;
  var toastStyles = React.useMemo(function () {
    return _extends({
      icon: {
        color: [MessageBarType.error, MessageBarType.blocked, MessageBarType.severeWarning].includes(messageBarType) ? nuOrderTheme.palette.error : messageBarType === MessageBarType.warning ? nuOrderTheme.palette.yellow : nuOrderTheme.palette.green
      },
      root: {
        backgroundColor: nuOrderTheme.palette.black,
        color: nuOrderTheme.palette.white
      },
      dismissal: {
        '& i': {
          color: nuOrderTheme.palette.white + " !important"
        }
      }
    }, styles != null ? styles : {});
  }, [styles, messageBarType]);
  return /*#__PURE__*/React.createElement(MessageBar, {
    styles: toastStyles,
    messageBarType: messageBarType,
    "data-test": testId,
    onDismiss: onDismiss
  }, children);
};

export { AlertDialog, Button, ButtonGroup, Checkbox, ChoiceGroup, ConfirmDialog, DialogTitle, Dropdown, FolderSync, Loading, PromptDialog, SvgIcon, TagPicker, Theme, ToastNotification, Toggle, customizations, icon12Subset, icon14Subset, icon18Subset, icon24Subset, icon64Subset, iconOverrideSubset, initializeIcons, nuOrderTheme, unregisterExistingIcons };
//# sourceMappingURL=components.esm.js.map
